window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value;
  },

  /**
   * Constructs an object of key / value pairs out of the parameters of the query string
   *
   * @return {Object}
   */
  getQueryParams: function() {
    var queryString = location.search && location.search.substr(1) || '';
    var queryParams = {};

    queryString
      .split('&')
      .filter(function (element) {
        return element.length;
      })
      .forEach(function (paramValue) {
        var splitted = paramValue.split('=');

        if (splitted.length > 1) {
          queryParams[splitted[0]] = splitted[1];
        } else {
          queryParams[splitted[0]] = true;
        }
      });

    return queryParams;
  },

  /**
   * Returns empty string or query string with '?' prefix
   *
   * @return (string)
   */
  getQueryString: function() {
    var queryString = location.search && location.search.substr(1) || '';

    // Add the '?' prefix if there is an actual query
    if(queryString.length){
      queryString = '?' + queryString;
    }

    return queryString;
  },

  /**
   * Constructs a version of the current URL with the passed in key value pair as part of the query string
   * Will also remove the key if an empty value is passed in
   * See: https://gist.github.com/niyazpk/f8ac616f181f6042d1e0
   *
   * @param {String} key
   * @param {String} value
   * @param {String} uri - optional, defaults to window.location.href
   * @return {String}
   */
  getUrlWithUpdatedQueryStringParameter: function(key, value, uri) {

    uri = uri || window.location.href;

    // remove the hash part before operating on the uri
    var i = uri.indexOf('#');
    var hash = i === -1 ? ''  : uri.substr(i);
    uri = i === -1 ? uri : uri.substr(0, i);

    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";

    if (!value) {
      // remove key-value pair if value is empty
      uri = uri.replace(new RegExp("([?&]?)" + key + "=[^&]*", "i"), '');
      if (uri.slice(-1) === '?') {
        uri = uri.slice(0, -1);
      }
      // replace first occurrence of & by ? if no ? is present
      if (uri.indexOf('?') === -1) uri = uri.replace(/&/, '?');
    } else if (uri.match(re)) {
      uri = uri.replace(re, '$1' + key + "=" + value + '$2');
    } else {
      uri = uri + separator + key + "=" + value;
    }
    return uri + hash;
  },

  /**
   * Constructs a version of the current URL with the passed in parameter key and associated value removed
   *
   * @param {String} key
   * @return {String}
   */
  getUrlWithRemovedQueryStringParameter: function(parameterKeyToRemove, uri) {
    uri = uri || window.location.href;

    var rtn = uri.split("?")[0],
        param,
        params_arr = [],
        queryString = (uri.indexOf("?") !== -1) ? uri.split("?")[1] : "";

    if (queryString !== "") {
        params_arr = queryString.split("&");
        for (var i = params_arr.length - 1; i >= 0; i -= 1) {
            param = params_arr[i].split("=")[0];
            if (param === parameterKeyToRemove) {
                params_arr.splice(i, 1);
            }
        }
         if (params_arr.length > 0) { 
          rtn = rtn + "?" + params_arr.join("&");
        }
    }

    return rtn;
  },  

  /**
   * Check if we're running the theme inside the theme editor
   *
   * @return {bool}
   */
  isThemeEditor: function() {
    return window.Shopify && window.Shopify.designMode;
  },

  /**
   * Get the name of the correct 'transitionend' event for the browser we're in
   *
   * @return {string}
   */
  whichTransitionEnd: function() {
    var t;
    var el = document.createElement('fakeelement');
    var transitions = {
      'transition':'transitionend',
      'OTransition':'oTransitionEnd',
      'MozTransition':'transitionend',
      'WebkitTransition':'webkitTransitionEnd'
    };

    for(t in transitions){
      if( el.style[t] !== undefined ){
        return transitions[t];
      }
    }
  },

  /**
   * Adds user agent classes to the document to target specific browsers
   *
   */
  userAgentBodyClass: function() {
    var ua = navigator.userAgent,
        d = document.documentElement,
        classes = d.className,
        matches;

    // Detect iOS (needed to disable zoom on form elements)
    // http://stackoverflow.com/questions/9038625/detect-if-device-is-ios/9039885#9039885
    if ( /iPad|iPhone|iPod/.test(ua) && !window.MSStream ) {
      classes += ' ua-ios';

      // Add class for version of iOS
      matches = ua.match(/((\d+_?){2,3})\slike\sMac\sOS\sX/);
      if ( matches ) {
        classes += ' ua-ios-' + matches[1];// e.g. ua-ios-7_0_2
      }

      // Add class for Twitter app
      if ( /Twitter/.test(ua) ) {
        classes += ' ua-ios-twitter';
      }

      // Add class for Chrome browser
      if ( /CriOS/.test(ua) ) {
        classes += ' ua-ios-chrome';
      }
    }

    // Detect Android (needed to disable print links on old devices)
    // http://www.ainixon.me/how-to-detect-android-version-using-js/
    if ( /Android/.test(ua) ) {
      matches = ua.match(/Android\s([0-9\.]*)/);
      classes += matches ? ' ua-aos ua-aos-' + matches[1].replace(/\./g,'_') : ' ua-aos';
    }

    // Detect webOS (needed to disable optimizeLegibility)
    if ( /webOS|hpwOS/.test(ua) ) {
      classes += ' ua-webos';
    }

    // Detect Samsung Internet browser
    if ( /SamsungBrowser/.test(ua) ) {
      classes += ' ua-samsung';
    }

    d.className = classes;
  },

  /**
   * Generates a 32 bit integer from a string
   * Reference - https://stackoverflow.com/a/7616484
   *
   * @param {string}
   * @return {int}
   */
  hashFromString: function(string) {
    var hash = 0, i, chr;
    if (string.length === 0) return hash;
    for (i = 0; i < string.length; i++) {
      chr   = string.charCodeAt(i);
      hash  = ((hash << 5) - hash) + chr;
      hash |= 0; // Convert to 32bit integer
    }
    return hash;
  },

  chosenSelects: function($container) {
    var $selects = $container ? $('select.form-control', $container) : $('select.form-control');
    $selects.not('[data-no-chosen]').chosen();
  },

  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  },

  /**
   * Pluralizes the unit for the nuber passed in.
   * Usage mirrors the Shopify "pluralize" string filter
   *
   * @param {Number} number
   * @param {String} singular
   * @param {String} plural
   * @return {String}
   */
  pluralize: function(number, singular, plural)  {
    var output = '';

    number = parseInt(number);

    if(number == 1) {
      output = singular;
    }
    else {
      output = plural;
      if (typeof plural == "undefined") {
        output = singular + 's'; // last resort, turn singular into a plural
      }
    }
    return output;
  },

  /**
   * Pads a number with leading character (z) up to the specified width
   *
   * @param {Number} n
   * @param {Number} width
   * @param {Number} z - pad value
   * @return {Number}
   */
  pad: function(n, width, z) {
    z = z || '0';
    n = n + '';
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
  }
  
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {

  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTables: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;
    
    options.$tables.addClass('table');
    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },  

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + options.iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  /**
   * Removes '.00' if found at the end of the string
   *
   * @param  {string} value - formatted price (see above)
   * @return {string} value - formatted value
   */
  function stripZeroCents(string) {
    return string.replace(/\.00$/,'');
  }

  return {
    formatMoney: formatMoney,
    stripZeroCents: stripZeroCents
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */
  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();

/**
 * AJAX Cart scripts
 * ------------------------------------------------------------------------------
 * 
 * Usage: slate.AjaxCart.init(options);
 *
 */

(function($, Handlebars, slate){

  if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

  /*============================================================================
    API Functions
  ==============================================================================*/

 /**
  * AJAX submit an 'add to cart' form
  *
  * @param {jQuery} $form - jQuery instance of the form
  * @return {Promise} - Resolve returns JSON cart | Reject returns an error message
  */
  ShopifyAPI.addItemFromForm = function($form) {
    var promise = $.Deferred();

    $.ajax({
      type: 'post',
      dataType: 'json',
      url: '/cart/add.js',
      data: $form.serialize(),
      success: function () {
        ShopifyAPI.getCart().then(function (data) {
          promise.resolve(data);
        });
      },
      error: function () {
        promise.reject({
          message: 'Quantity is unavailable'
        });
      }
    });

    return promise;
  };

 /**
  * Retrieve a JSON respresentation of the users cart
  *
  * @return {Promise} - JSON cart
  */
  ShopifyAPI.getCart = function() {
    var promise = $.Deferred();
    
    $.ajax({
      type: 'get',
      url: '/cart?view=json',
      success: function (data) {
        var cart = JSON.parse(data);
        promise.resolve(cart);
      },
      error: function () {
        promise.reject({
          message: 'Could not retrieve cart items'
        });
      }
    });

    return promise;
  };

 /**
  * Retrieve a JSON respresentation of the users cart
  *
  * @return {Promise} - JSON cart
  */
  ShopifyAPI.getProduct = function(handle) {
    return $.getJSON('/products/' + handle + '.js');
  };  

 /**
  * Change the quantity of an item in the users cart
  *
  * @param {int} variantId - Variant to be adjust
  * @param {int} qty - New quantity of the variant
  * @return {Promise} - JSON cart
  */
  ShopifyAPI.changeItemQuantity = function(variantId, qty) {
    return $.ajax({
      type: 'post',
      dataType: 'json',
      url: '/cart/change.js',
      data: 'quantity=' + qty + '&id=' + variantId
    });
  };

 /**
  * Change the quantity of all line items in the cart
  *
  * @param {array} - quantities based on line item index
  * @return {Promise} - JSON cart
  */
  ShopifyAPI.updateItemQuantities = function(quantities) {
    var promise = $.Deferred();
    
    $.ajax({
      type: 'post',
      dataType: 'json',
      url: '/cart/update.js',
      data: {
        updates: quantities
      },
      success: function (cart) {
        promise.resolve(cart);
      },
      error: function () {
        promise.reject({
          message: 'Could not retrieve cart items'
        });
      }      
    });

    return promise; 
  }

  /*============================================================================
    Ajax Shopify Add To Cart
  ==============================================================================*/
  slate.AjaxCart = (function() {
    
    var $window = $(window);
    var $body = $('body');

    var selectors = {
      container: '[data-ajax-cart-container]',
      template: 'script[data-ajax-cart-template]',
      trigger: '[data-ajax-cart-trigger]',
      close: '[data-ajax-cart-close]',
      addForm: 'form[action^="/cart/add"]',
      addToCart: '[data-add-to-cart]',
      addToCartText: '[data-add-to-cart-text]',
      header: '[data-ajax-cart-header]',
      body: '[data-ajax-cart-body]',
      footer: '[data-ajax-cart-footer]',
      item: '[data-ajax-item][data-id][data-qty]',
      itemRemove: '[data-ajax-cart-item-remove]',
      itemIncrement: '[data-ajax-cart-item-increment]',
      itemDecrement: '[data-ajax-cart-item-decrement]',
      listWrapper: '[data-ajax-cart-list-wrapper]',
      list: '[data-ajax-cart-list]',
      cartBadge: '[data-cart-badge]',
      cartBadgeCount: '[data-cart-badge-count]',

      confirmModal: '[data-ajax-cart-confirm-modal]',
      confirmCheckoutLink: '[data-confirm-checkout-link]'
    };

    var classes = {
      bodyCartOpen: 'ajax-cart-open',
      backdrop: 'ajax-cart-backdrop',
      backdropVisible: 'is-visible',
      cartOpen: 'is-open',
      cartBadgeHasItems: 'has-items',
      cartRequestInProgress: 'request-in-progress'
    };

   /**
    * AjaxCart constructor
    *
    * Adds an `init` method with access to private variables inside the contructor
    */
    function AjaxCart() {
      this.name = 'ajaxCart';
      this.namespace = '.' + this.name;
      this.events = {
        RENDER:  'render'  + this.namespace,
        DESTROY: 'destroy' + this.namespace,
        SCROLL:  'scroll'  + this.namespace,
        UPDATE:  'update'  + this.namespace, //  Use this as a global event to hook into whenever the cart changes
        RESIZE:  'resize' + this.namespace
      };   

      var initialized = false;
      var settings = {
        disableAjaxCart: false,
        backdrop: true
      };

      this.$el                = $(selectors.container);
      this.$confirmModal      = null;
      this.$backdrop          = null;
      this.stateIsOpen        = null;
      this.transitionEndEvent = slate.utils.whichTransitionEnd();
      this.requestInProgress  = false;
      this.cartImageSize      = 'x300';

     /**
      * Initialize the cart
      *
      * @param {object} options - see `settings` variable above
      */
      this.init = function(options) {
        if(initialized) return;

        this.settings = $.extend(settings, options);

        if(!$(selectors.template).length){
          console.warn('['+this.name+'] - Handlebars template required to initialize');
          return;
        }

        this.$container      = $(selectors.container);
        this.$cartBadge      = $(selectors.cartBadge);
        this.$cartBadgeCount = $(selectors.cartBadgeCount);
        this.$confirmModal   = $(selectors.confirmModal);

        // Compile this once during initialization
        this.template = Handlebars.compile($(selectors.template).html());

        // Add the AJAX part
        if(!this.settings.disableAjaxCart) {
          this._formOverride();
        }

        // Add event handlers here
        this.$el.on('submit', 'form', this.onFormSubmit.bind(this));
        this.$confirmModal.on('click', selectors.confirmCheckoutLink, this.onConfirmCheckoutLinkClick.bind(this));
        $body.on('click', selectors.trigger, this.onTriggerClick.bind(this));
        $body.on('click', selectors.close, this.onCloseClick.bind(this));
        $body.on('click', selectors.itemRemove, this.onItemRemoveClick.bind(this));
        $body.on('click', selectors.itemIncrement, this.onItemIncrementClick.bind(this));
        $body.on('click', selectors.itemDecrement, this.onItemDecrementClick.bind(this));
        $window.on(this.events.RENDER, this.onCartRender.bind(this));
        $window.on(this.events.DESTROY, this.onCartDestroy.bind(this));
        $window.on(this.events.RESIZE, this.onResize.bind(this));

        // Get the cart data when we initialize the instance
        ShopifyAPI.getCart().then(function(cart) {
          
          var cartContainsMultipleStylesOfQuantityRestrictedProducts = false;
          var productIds = [];
          var quantities = []; // Use this to reset all cart item quantities back to 1 if needed

          // 2 Ways a person can add multiple styles of a product
          // Add more than one of a variant to the cart OR add different variants of the same product
          for (var i = 0; i < cart.items.length; i++) {
            var item = cart.items[i];

            if(item.is_quantity_restricted) {
              if(productIds.indexOf(item.product_id) == -1) {
                productIds.push(item.product_id);
                if(item.quantity > 1) {
                  cartContainsMultipleStylesOfQuantityRestrictedProducts = true;
                }
                quantities.push(1);
              }
              else {
                // product has already been added via another variant
                cartContainsMultipleStylesOfQuantityRestrictedProducts = true;
                quantities.push(0);
              }
            }
            else {
              quantities.push(item.quantity);
            }
            
          }

          // They somehow managed to add multple of some products to the cart
          // A lot of promise chaining here but this won't run 99% of the time
          if(cartContainsMultipleStylesOfQuantityRestrictedProducts) {
            ShopifyAPI.updateItemQuantities(quantities).then(ShopifyAPI.getCart).then(this.buildCart.bind(this));
          }
          else {
            this.buildCart(cart);  
          }
      
        }.bind(this));

        initialized = true;

        return initialized;
      };

      return this;
    }

    AjaxCart.prototype = $.extend({}, AjaxCart.prototype, {

     /**
      * Call this function to AJAX-ify any add to cart forms on the page
      */
      _formOverride: function() {
        var _this = this;

        $body.on('submit', selectors.addForm, function(e) {
          e.preventDefault();

          if(this.requestInProgress) return;

          var $form = $(e.target);
          var $submitButton = $form.find(selectors.addToCart);
          var $submitButtonText = $submitButton.find(selectors.addToCartText);

          // Update the submit button text and disable the button so the user knows the form is being submitted
          $submitButton.prop('disabled', true);
          $submitButtonText.html(theme.strings.adding);

          this._onRequestStart();

          ShopifyAPI.addItemFromForm( $form )
            .then(function(data) {
              _this._onRequestFinish();
              // Reset button state
              $submitButton.prop('disabled', false);
              $submitButtonText.html(theme.strings.addToCart);
              _this.onItemAddSuccess.call(_this, data);
            })
            .fail(function(data) {
              _this._onRequestFinish();
              // Reset button state
              $submitButton.prop('disabled', false);
              $submitButtonText.html(theme.strings.addToCart);
              _this.onItemAddFail.call(_this, data);
            });
        }.bind(this));
      },  

     /**
      * Ensure we are working with a valid number
      *
      * @param {int|string} qty
      * @return {int} - Integer quantity.  Defaults to 1
      */
      _validateQty: function(qty) {
        return (parseFloat(qty) == parseInt(qty)) && !isNaN(qty) ? qty : 1;
      },

     /**
      * Ensure we are working with a valid number
      *
      * @param {element} el - cart item row or child element
      * @return {obj}
      */
      _getItemRowAttributes: function(el) {
        var $el = $(el);
        var $row = $el.is(selectors.item) ? $el : $el.parents(selectors.item);

        return {
          $row: $row,
          id:  $row.data('id'),
          qty: this._validateQty($row.data('qty'))
        };
      },

      _onRequestStart: function() {
        this.requestInProgress = true;
        this.$el.addClass(classes.cartRequestInProgress);
      },

      _onRequestFinish: function() {
        this.requestInProgress = false;
        this.$el.removeClass(classes.cartRequestInProgress);
      },      

      addBackdrop: function() {

        var _this = this;

        if(this.stateIsOpen) {
          this.$backdrop = $(document.createElement('div'));

          this.$backdrop.addClass(classes.backdrop)
                        .appendTo($body);

          this.$backdrop.one('click', this.close.bind(this));

          // debug this...
          setTimeout(function() {
            _this.$backdrop.addClass(classes.backdropVisible);
          }, 10);
        }
      },

      removeBackdrop: function() {

        var _this = this;

        if(!this.stateIsOpen && this.$backdrop) {
          this.$backdrop.one(this.transitionEndEvent, function(){
            _this.$backdrop && _this.$backdrop.remove();
            _this.$backdrop = null;
          });

          setTimeout(function() {
            _this.$backdrop.removeClass(classes.backdropVisible);
          }, 10);
        }
      },

      onResize: function() {
        var $listWrapper = $(selectors.listWrapper, this.$container);
        var $list = $(selectors.list, this.$container);

        if($listWrapper.length == 0 || $list.length == 0) {
          return;
        }

        if($listWrapper.outerWidth() < $list.get(0).scrollWidth) {
          $listWrapper.addClass('has-overflow');
        }
        else {
          $listWrapper.removeClass('has-overflow');
        }
      },

     /**
      * Callback when adding an item is successful
      *
      * @param {Object} cart - JSON representation of the cart.
      */
      onItemAddSuccess: function(cart){
        this.buildCart(cart);
        this.open();
      },

     /**
      * Callback when adding an item fails

      * @param {Object} data
      * @param {string} data.message - error message
      */
      onItemAddFail: function(data){
        var text = data.message

        if (text.toLowerCase() === 'quantity is unavailable') {
          text = 'Requested Quantity Unavailable'
        }

        new slate.models.SlideupAlert({ text: text });
      },

      /**
      * Callback for when the cart HTML is rendered to the page
      * Allows us to add event handlers for events that don't bubble
      */
      onCartRender: function(e) {
        this.onResize();
      },

     /**
      * Callback for when the cart HTML is removed from the page
      * Allows us to do cleanup on any event handlers applied post-render
      */
      onCartDestroy: function(e) {
      },

     /**
      * Builds the HTML for the ajax cart.
      * Modifies the JSON cart for consumption by our handlebars template
      *
      * @param {object} cart - JSON representation of the cart.  See https://help.shopify.com/themes/development/getting-started/using-ajax-api#get-cart
      * @return ??
      */
      buildCart: function(cart) {

        var self = this;

        // All AJAX Cart requests finish with rebuilding the cart
        // So this is a good place to add this code
        this._onRequestFinish();

        // Make adjustments to the cart object contents before we pass it off to the handlebars template
        cart.total_price = slate.Currency.formatMoney(cart.total_price, theme.moneyFormat);
        cart.item_count_label = cart.item_count + ' ' + slate.utils.pluralize(cart.item_count, 'Item', 'Items');

        cart.items.map(function(item){
          item.image    = slate.Image.getSizedImageUrl(item.image, self.cartImageSize);
          item.price    = slate.Currency.formatMoney(item.price, theme.moneyFormat);
          item.quantity_label = item.quantity > 1 ? ('x ' + item.quantity) : '';
          item.unavailable = !item.available;

          // Adjust the item's variant options to add "name" and "value" properties
          if(item.hasOwnProperty('product')) {
            var product = item.product;
            for (var i = item.variant_options.length - 1; i >= 0; i--) {
              var name  = product.options[i];
              var value = item.variant_options[i];

              item.variant_options[i] = {
                name: name,
                value: value
              };

              // Don't show this info if it's the default variant that Shopify creates
              if(value == "Default Title") {
                delete item.variant_options[i];
              }
            }
          }

          return item;
        });

        /**
         *  You can also use this as an intermediate step to constructing the AJAX cart DOM
         *  by returning an HTML string and using another function to do the DOM updating
         *
         *  return this.template(cart)
         *
         *  The code below isn't the most elegant way to update the cart but it works...
         */        

        $window.trigger(this.events.DESTROY);

        // if(this.isOpen()) {
        //   this.$container.fadeOut(1000, function() {
        //     this.$container.empty().append( this.template(cart) );
        //     this.$container.fadeIn(1000);
        //     $window.trigger(this.events.RENDER);
        //     $window.trigger(this.events.UPDATE);
        //   }.bind(this));
        // }
        // else {
          this.$container.empty().append( this.template(cart) );
          $window.trigger(this.events.RENDER);
          $window.trigger( $.Event(this.events.UPDATE, { cart : cart }) );
        // }

        this.updateCartCount(cart);
      },

     /**
      * Update the cart badge + count here
      *
      * @param {Object} cart - JSON representation of the cart.
      */
      updateCartCount: function(cart) {

        this.$cartBadgeCount.html(cart.item_count);

        if(cart.item_count) {
          this.$cartBadge.addClass(classes.cartBadgeHasItems);
        }
        else {
          this.$cartBadge.removeClass(classes.cartBadgeHasItems);
        }
      },

     /**
      * Remove the item from the cart.  Extract this into a separate method if there becomes more ways to delete an item
      *
      * @param {event} e - Click event
      */
      onItemRemoveClick: function(e) {
        e.preventDefault();

        if(this.requestInProgress) return;

        var attrs = this._getItemRowAttributes(e.target);

        this._onRequestStart();
        ShopifyAPI.changeItemQuantity(attrs.id, 0).then(ShopifyAPI.getCart).then(this.buildCart.bind(this));
      },

     /**
      * Increase the quantity of an item by 1
      *
      * @param {event} e - Click event
      */
      onItemIncrementClick: function(e) {
        e.preventDefault();

        if(this.requestInProgress) return;

        var attrs = this._getItemRowAttributes(e.target);

        this._onRequestStart();
        ShopifyAPI.changeItemQuantity(attrs.id, attrs.qty + 1).then(ShopifyAPI.getCart).then(this.buildCart.bind(this));
      },

     /**
      * Decrease the quantity of an item by 1
      *
      * @param {event} e - Click event
      */
      onItemDecrementClick: function(e) {
        e.preventDefault();

        if(this.requestInProgress) return;

        var attrs = this._getItemRowAttributes(e.target);
        var newQty = (attrs.qty < 1 ? 0 : attrs.qty - 1);

        this._onRequestStart();
        ShopifyAPI.changeItemQuantity(attrs.id, newQty).then(ShopifyAPI.getCart).then(this.buildCart.bind(this));
      },

     /**
      * Click the 'ajaxCart - trigger' selector
      *
      * @param {event} e - Click event
      */
      onTriggerClick: function(e) {
        e.preventDefault();
        this.toggleVisibility();
      },

     /**
      * Click the 'ajaxCart - close' selector
      *
      * @param {event} e - Click event
      */
      onCloseClick: function(e) {
        e.preventDefault();

        // Do any cleanup before closing the cart
        this.close();
      },

     /**
      * Opens / closes the cart depending on state
      *
      */
      toggleVisibility: function() {
        return this.stateIsOpen ? this.close() : this.open();
      },

     /**
      * Check the open / closed state of the cart
      *
      * @return {bool}
      */
      isOpen: function() {
        return this.stateIsOpen;
      },

     /**
      * Returns true is the cart is closed.
      *
      * @return {bool}
      */
      isClosed: function() {
        return !this.stateIsOpen;
      },

     /**
      * STUB METHOD - Code for opening the cart
      */
      open: function() {
        if(this.stateIsOpen) return;
        this.stateIsOpen = true;

        if(this.settings.backdrop) {
          this.addBackdrop();
        }

        $body.addClass(classes.bodyCartOpen);
        this.$el.addClass(classes.cartOpen);
      },

     /**
      * STUB METHOD - Code for closing the cart
      */
      close: function() {
        if(!this.stateIsOpen) return;

        this.stateIsOpen = false;

        this.$el.removeClass(classes.cartOpen);
  
        if(this.settings.backdrop) {
          this.removeBackdrop();
        }

        $body.removeClass(classes.bodyCartOpen);
      },

     /**
      * Called when someone submits the ajax cart form to go to checkout
      *
      * @param {event} e - Submit Event
      */
      onFormSubmit: function(e) {
        if (this.$confirmModal && this.$confirmModal.length === 1) {
          this.$confirmModal.modal('show');
          return false;
        }

        return true;
      },

      onConfirmCheckoutLinkClick: function(e) {
        $(e.currentTarget)
          .attr('disabled', true)
          .text('Redirecting to Checkout..');
      }
    });

    return AjaxCart;
  })();

})(jQuery, Handlebars, slate);


/**
 * AJAX MailChimp Library
 * -----------------------------------------------------------------------------
 * Heavily modified version of the original jQuery plugin - https://github.com/scdoshi/jquery-ajaxchimp
 * Handles AJAX form submission and provides hooks for lifecycle events.
 *
 * Usage:
 *
 *   var $form = $('form');
 *   var ajaxForm = new slate.AjaxMailChimpForm($form, {
 *     onInit: function() {
 *       // ...
 *     }
 *   });
 *
 * @namespace ajaxMailChimpForm
 */


slate.AjaxMailChimpForm = (function($) {

 /**
  * AJAX MailChimp Form Contructor
  *
  * @param {HTMLElement | jQuery} form - Form element
  * @param {Object} options
  * @param {Function} options.onInit
  * @param {Function} options.onDestroy
  * @param {Function} options.onBeforeSend - Prevent AJAX submission by returning false here
  * @param {Function} options.onSubmitFail
  * @param {Function} options.onSubscribeSuccess
  * @param {Function} options.onSubscribeFail
  * @return {self}
  */
  function AjaxMailChimpForm(form, options) {

    this.name = 'ajaxMailChimpForm';
    this.namespace = '.' + this.name;
    this.events = {
      SUBMIT: 'submit' + this.namespace
    };

    var _this = this;
    var defaults = {
      onInit: $.noop,
      onDestroy: $.noop,
      onBeforeSend: $.noop,
      onSubmitFail: $.noop,
      onSubscribeSuccess: $.noop,
      onSubscribeFail: $.noop
    };

    if (form.length === 0) {
      return false;
    }

    this.$form    = form instanceof jQuery ? form : $(form);
    this.$input   = this.$form.find('input[type="email"]');
    this.$submit  = this.$form.find('[type="submit"]');
    this.settings = $.extend({}, defaults, options);

    if(this.$input.attr('name') != "EMAIL") {
      console.warn('['+this.name+'] - Email input *must* have attribute [name="EMAIL"]');
    }

    this.$form.on(this.events.SUBMIT, this.onFormSubmit.bind(_this));

    this.settings.onInit();

    return this;
  }

  AjaxMailChimpForm.prototype = $.extend({}, AjaxMailChimpForm.prototype, {
    regexes: {
      error: {
        1: /Please enter a value/,
        2: /An email address must contain a single @/,
        3: /The domain portion of the email address is invalid \(the portion after the @: (.+)\)/,
        4: /The username portion of the email address is invalid \(the portion before the @: (.+)\)/,
        5: /This email address looks fake or invalid. Please enter a real email address/,
        6: /.+\#6592.+/,
        7: /(.+@.+) is already subscribed to list (.+)\..+<a href.+/
      }
    },
    responses: {
      success: 'Thank you for subscribing!',
      error: {
        1: 'Please enter an email address',
        2: 'There was a problem with your entry. Please check the address and try again.',
        3: 'There was a problem with your entry. Please check the address and try again.',
        4: 'There was a problem with your entry. Please check the address and try again.',
        5: 'There was a problem with your entry. Please check the address and try again.',
        6: 'Too many subscribe attempts for this email address. Please try again in about 5 minutes.',
        7: 'You\'re already subscribed. Thank you!'
      }
    },
    getRegexMatch: function(string, stringKey) {
      var regexPatterns = this.regexes[stringKey];
      var matchedId;
      $.each(regexPatterns, function(id, regexPattern) {
        if (string.match(regexPattern) !== null) {
          matchedId = id;
          return false;
        }
      });
      return matchedId;
    },
    getMessageForResponse: function(response) {
      var msg;
      if (response.result === 'success') {
        msg = this.responses.success;
      } else {
        var index = -1;
        try {
          var parts = response.msg.split(' - ', 2);
          if (parts[1] === undefined) {
            msg = response.msg;
          } else {
            msg = parts[1];
          }
        } catch (e) {
          msg = response.msg;
        }

        // Now that we have the relevant part of the message, lets get the actual string for it
        var regexPattern = this.regexes.error;
        var matchedId = this.getRegexMatch(msg, 'error');
        if (matchedId && regexPattern[matchedId] && this.responses.error[matchedId]) {
          return msg.replace(regexPattern[matchedId], this.responses.error[matchedId]);
        }
      }

      return msg;
    },
    destroy: function() {
      this.$form.off(this.events.SUBMIT);
      this.settings.onDestroy();
    },
    onBeforeSend: function() {
      if(this.settings.onBeforeSend() == false) {
        return false;
      }

      if (this.$input.val() && this.$input.val().length) {
        this.$submit.prop('disabled', true);
        return true;
      } else {
        this.$input.parents('.form-group').addClass('alert-info');
      }
      return false;
    },
    onSubmitDone: function(response) {
      var rspMsg = this.getMessageForResponse(response);
      this.$submit.prop('disabled', false);
      response.result === 'success' ? this.settings.onSubscribeSuccess(rspMsg) : this.settings.onSubscribeFail(rspMsg);
    },
    onSubmitFail: function(response) {
      this.settings.onSubmitFail();
    },
    onFormSubmit: function(e) {
      e.preventDefault();
      var _this = this;
      var $form = this.$form;
      var data = {};
      var dataArray = $form.serializeArray();

      // See - https://github.com/scdoshi/jquery-ajaxchimp/blob/master/jquery.ajaxchimp.js
      $.each(dataArray, function(index, item) {
        data[item.name] = item.value;
      });

      $.ajax({
          url: $form.attr('action').replace('/post?', '/post-json?').concat('&c=?'),
          dataType: 'jsonp',
          data: data,
          beforeSend: _this.onBeforeSend.bind(_this)
        })
        .done(function(response) {
          _this.onSubmitDone(response);
        })
        .fail(function(response) {
          _this.onSubmitFail(response);
        });

      return false;
    }
  });

  return AjaxMailChimpForm;
})(jQuery);

/**
 * AJAX Klaviyo Library
 * -----------------------------------------------------------------------------
 * Handles AJAX form submission and callback event
 *
 * Usage:
 *
 *   var $form = $('form');
 *   var listId = $form.data('list-id');
 *   var source = $form.data('source');
 *
 *   var options = {
 *     listId: listId,
 *     source: source,
 *     onSubscribeSuccess: function() { .. },
 *     onSubmitFail: function(){ .. }
 *   };
 *
 *   var ajaxKlaviyoForm = new slate.AjaxKlaviyoForm($form, options);
 *
 * @namespace ajaxKlaviyoForm
 */


slate.AjaxKlaviyoForm = (function($) {

 /**
  * AJAX Klaviyo Form Constructor
  *
  * @param {HTMLElement | jQuery} form - Form element
  * @param {Object} options
  * @param {String} options.listId - Klaviyo List ID
  * @param {String} options.source - Klaviyo custom $source property
  * @param {Function} options.onInit
  * @param {Function} options.onBeforeSend - Prevent AJAX submission by returning false here
  * @param {Function} options.onSubmitFail  
  * @param {Function} options.onSubscribeSuccess
  * @param {Function} options.onSubscribeFail
  * @return {self}
  */
  function AjaxKlaviyoForm(form, options) {

    this.name = 'ajaxKlaviyoForm';
    this.namespace = '.' + this.name;
    this.events = {
      SUBMIT: 'submit' + this.namespace
    };

    var _this = this;
    var defaults = {
      source: "Shopify Form",
      onInit: $.noop,
      onBeforeSend: $.noop,
      onSubmitFail: $.noop,
      onSubscribeSuccess: $.noop,
      onSubscribeFail: $.noop
    };

    if (form.length === 0) {
      return false;
    }

    this.$form    = form instanceof jQuery ? form : $(form);
    this.$input   = this.$form.find('input[type="email"]');
    this.$submit  = this.$form.find('[type="submit"]');
    this.settings = $.extend({}, defaults, options);

    if(!this.settings.listId) {
      console.warn('['+this.name+'] - Valid Klaviyo List ID required to initialize');
      return;
    }

    this.$form.on(this.events.SUBMIT, this.onFormSubmit.bind(_this));

    this.settings.onInit();

    return this;
  }

  AjaxKlaviyoForm.prototype = $.extend({}, AjaxKlaviyoForm.prototype, {
    onBeforeSend: function() {
      
      if(this.settings.onBeforeSend() == false) {
        return false;
      }

      if (this.$input.val() && this.$input.val().length) {
        this.$submit.prop('disabled', true);
        return true;
      } else {
        this.$input.parents('.form-group').addClass('alert-info');
      }

      return false;
    },
    onSubmitDone: function(response) {

      this.$submit.prop('disabled', false);

      if(response.success) {
        this.settings.onSubscribeSuccess();
      }
      else {
        this.settings.onSubscribeFail();
      }
    },
    onSubmitFail: function(errors) {

      this.$submit.prop('disabled', false);

      if(errors instanceof Array && errors.length) {
        for (var i = errors.length - 1; i >= 0; i--) {
          console.warn('['+this.name+'] - onSubmitFail error: "' + errors[i] + '"');
        }
      }
      this.settings.onSubmitFail(errors);
    },
    onFormSubmit: function(e) {
      e.preventDefault();
      var _this = this;

      $.ajax({
          async: true,
          crossDomain: true,
          url: "https://manage.kmail-lists.com/subscriptions/external/subscribe",
          method: "POST",
          headers: {
              "content-type": "application/x-www-form-urlencoded",
              "cache-control": "no-cache"
          },
          data: {
              "g": this.settings.listId,
              "$fields": "$source",
              "email": this.$input.val(),
              "$source": this.settings.source
          },
          beforeSend: _this.onBeforeSend.bind(_this)
        })
        .done(function(response) {
          _this.onSubmitDone(response);
        })
        .fail(function(jqXHR, textStatus) {        
          var errors = [];
          if(jqXHR && jqXHR.responseJSON && jqXHR.responseJSON.hasOwnProperty('errors')) {
              errors = jqXHR.responseJSON.errors;
            }

          _this.onSubmitFail(errors);
        });

      return false;
    }
  });

  return AjaxKlaviyoForm;
})(jQuery);

/**
 * Animation Helper Functions / constants
 * -----------------------------------------------------------------------------
 * A collection of functions that help with animations in javascript
 *
 */

slate.animations = (function($) {

  // First add some extra easing equations
  // To add more see the full library - https://github.com/danro/jquery-easing/blob/master/jquery.easing.js
  $.extend( $.easing, {
    // t: current time, b: begInnIng value, c: change In value, d: duration
    easeInCubic: function (x, t, b, c, d) {
      return c*(t/=d)*t*t + b;
    },
    easeOutCubic: function (x, t, b, c, d) {
      return c*((t=t/d-1)*t*t + 1) + b;
    },
    easeInOutCubic: function (x, t, b, c, d) {
      if ((t/=d/2) < 1) return c/2*t*t*t + b;
      return c/2*((t-=2)*t*t + 2) + b;
    },
    easeInQuart: function (x, t, b, c, d) {
      return c*(t/=d)*t*t*t + b;
    },
    easeOutQuart: function (x, t, b, c, d) {
      return -c * ((t=t/d-1)*t*t*t - 1) + b;
    },
    easeInOutQuart: function (x, t, b, c, d) {
      if ((t/=d/2) < 1) return c/2*t*t*t*t + b;
      return -c/2 * ((t-=2)*t*t*t - 2) + b;
    },   
    easeInQuint: function (x, t, b, c, d) {
      return c*(t/=d)*t*t*t*t + b;
    },
    easeOutQuint: function (x, t, b, c, d) {
      return c*((t=t/d-1)*t*t*t*t + 1) + b;
    },
    easeInOutQuint: function (x, t, b, c, d) {
      if ((t/=d/2) < 1) return c/2*t*t*t*t*t + b;
      return c/2*((t-=2)*t*t*t*t + 2) + b;
    }
  });

  // Easing functions for use throughout the site.
  // The ones above are written for use by jQuery and are overly complex
  // The only parameter here is t which should be normalized to fall between 0 and 1
  var easingFunctions = {
    easeInCubic: function(t) {
      return Math.pow(t, 2);
    },
    easeOutCubic: function(t) {
      return 1 - Math.pow(1-t, 2);
    }
  };  

  // Match those set in variables.scss
  var _transitionTimingDurations = {
    base:     500,
    fast:     200,
    fastest:  50,
    slow:     1000,
    medium:   700,
    none:     0
  };

  var _transitionTimingFunctions = {
    base:      'ease-in-out',
    in:        'ease-out',
    out:       'ease-in',
    inOutUI:   'cubic-bezier(0.42, 0, 0.13, 1.04)'
  };

 /**
  * Get one of the durations stored in the variable defined above
  * If the requested duration doesn't exist, fallback to the base
  *
  * @param {string} key - string matching one of the key names
  * @return {int} - duration in ms
  */
  function getTransitionTimingDuration(key) {
    var k = 'base';
    if(_transitionTimingDurations.hasOwnProperty(key)) {
      k = key;
    }
    return _transitionTimingDurations[k];
  }

 /**
  * Get one of the timing functions stored in the variable defined above
  * If the requested function doesn't exist, fallback to the base
  *
  * @param {string} key - string matching one of the key names
  * @return {string} - valid css timing function
  */
  function getTransitionTimingFunction(key) {
    var k = 'base';
    if(_transitionTimingFunctions.hasOwnProperty(key)) {
      k = key;
    }
    return _transitionTimingFunctions[k];
  }

  return {
    getTransitionTimingDuration: getTransitionTimingDuration,
    getTransitionTimingFunction: getTransitionTimingFunction,
    easingFunctions: easingFunctions
  };

}(jQuery));

/**
 * User Scripts
 * -----------------------------------------------------------------------------
 * Mostly handles cookie setting / removal, logic around user sessions
 *
 * @namespace user
 */

slate.user = (function(Cookies) {

  var cookiePrefix = '_defcon_';

 /**
  * User constructor
  */
  function User() {
    this.name = 'user';
    this.namespace = '.' + this.name;

    // Do any initialization here
    // For instance, you could increment a cookie that tracks visits to the site

    return this;
  }

  User.prototype = $.extend({}, User.prototype, {

   /**
    * Library of cookies to use throughout the site.
    * Use the `generateCookie` method below to create your own copies of these.  Don't access these directly.
    */
    _cookies: {
      siteVisit: {
        name: cookiePrefix + 'site_visit',
        value: true
      },
      subscriptionModalSeen: {
        name: 'subscriptionModal_seen',
        value: true
      },
      emailCollected: {
        name: 'emailCollected',
        value: true
      }      
    },

   /**
    * Creates and returns a copy of one of the cookies available above
    *
    * @param {String} key
    * @return {Object | undefined}
    */
    generateCookie: function(key) {
      var c;
      if(this._cookies.hasOwnProperty(key)) {
        c = $.extend(true, {}, this._cookies[key]);
        c.name = cookiePrefix + c.name;
      }
      else {
        console.warn('['+this.name+'] - Cannot create cookie.  Key "' + key + '" not found.' );
      }
      return c;
    },    
    
   /**
    * Sets a browser cookie
    *
    * @param {Object} cookie
    * @param {String} cookie.name
    * @param {String} cookie.value
    * @param {Number} cookie.expiration - Time to expire in days, expires after session if left blank
    */
    setCookie: function(cookie) {
      if(this.hasCookie(cookie.name) && this.getCookieValue(cookie.name) != cookie.value){
        this.removeCookie(cookie.name);
      }

      var opts = cookie.hasOwnProperty('expiration') ? { expires : cookie.expiration } : {};
      Cookies.set( cookie.name, cookie.value, opts );

      return this;
    },

   /**
    * Checks for the presence of a browser cookie by name (doesn't check for value equality)
    *
    * @param {String} cookieName
    * @return {Boolean}
    */
    hasCookie: function(cookieName) {
      return typeof Cookies.get( cookieName ) !== "undefined";
    },

   /**
    * Returns value of browser cookie by name
    *
    * @param {String} cookieName
    * @return {String | Undefined}
    */
    getCookieValue: function(cookieName) {
      return this.hasCookie( cookieName ) ? Cookies.get( cookieName ) : undefined;
    },

   /**
    * Removes a cookie by name
    *
    * @param {String} cookieName
    * @return {Self}
    */
    removeCookie: function(cookieName) {
      Cookies.remove( cookieName );
      return this;
    }
  });

  return new User();

}(Cookies));

/**
 * Breakpoint Helper Functions / constants
 * -----------------------------------------------------------------------------
 * A collection of functions that help with dealing with site breakpoints in JS
 * All breakpoint properties should be defined here
 *
 */

slate.breakpoints = (function($) {

  var $window = $(window);
  var cachedWindowWidth = $window.width(); 

  // Match those set in variables.scss
  var _breakpointMinWidths = {
    xs: 576,
    sm: 768,
    md: 992,
    lg: 1200,
    xl: 1480
  };

  var events = {
    BREAKPOINT_CHANGE: 'breakpointChange',
  };


 /**
  * Get one of the widths stored in the variable defined above
  *
  * @param {string} key - string matching one of the key names
  * @return {int} - pixel width
  */
  function getBreakpointMinWidth(key) {
    if(!key) return;

    if(_breakpointMinWidths.hasOwnProperty(key)) {
      return _breakpointMinWidths[key];
    }
  }

 /**
  * Gets the key for one of the breakpoint widths, whichever is closest but smaller to the passed in width
  * So if we pass in a width between 'sm' and 'md', this will return 'sm'
  *
  * @param {int} w - width
  * @return {undefined|string} foundKey
  */
  function getBreakpointMinWidthKeyForWidth(w) {
    w = w != undefined ? w : $window.width();
    
    var previousKey;
    var foundKey;

    $.each(_breakpointMinWidths, function(k, bpMinWidth) {
      if(w > bpMinWidth) {
        previousKey = k;
      }
      else {
        foundKey = previousKey;
      }
    });

    return foundKey;
  }

 /**
  * Triggers a window event when a breakpoint is crossed, passing the new minimum breakpoint width key as an event parameter
  *
  */
  function onResize() {
    var newWindowWidth = $window.width();

    $.each(_breakpointMinWidths, function(k, bpMinWidth) {
      if( (newWindowWidth >= bpMinWidth && cachedWindowWidth < bpMinWidth) || (cachedWindowWidth >= bpMinWidth && newWindowWidth < bpMinWidth) ) {
        
        var bpMinWidthKey = getBreakpointMinWidthKeyForWidth(newWindowWidth);
        var e = $.Event(events.BREAKPOINT_CHANGE, { bpMinWidthKey: bpMinWidthKey });
        $window.trigger(e);
        return false;

      }
    });

    cachedWindowWidth = $window.width();
  }

  $window.on('resize', $.throttle(20, onResize) );

  return {
    getBreakpointMinWidth: getBreakpointMinWidth,
    getBreakpointMinWidthKeyForWidth: getBreakpointMinWidthKeyForWidth
  };

}(jQuery));
/**
 * Product Detail Form Script
 * ------------------------------------------------------------------------------
 *
 * Handles all functionality related to contents of snippets/product-detail-form.liquid
 * Core functionality includes:
 *  - Variant selecting + callbacks
 *  - Variant gallery + slideshow initializing
 *
 * Requires:
 *  - jQuery
 *  - Modernizr (for Modernizr.touchevents)
 *  - Slate (for slate.Currency)
 */

// Requires slate for slate.Currency

slate.ProductDetailForm = (function($, Modernizr, slate) {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    addForm: 'form[action^="/cart/add"]',
    productPrice: '[data-product-price]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',

    productGallery: '[data-product-gallery]',
    productGallerySlideshow: '[data-product-gallery-slideshow]',
    productGallerySlideLink: '[data-product-gallery-slide-link]',  
    productGalleryCurrentIndex: '[data-product-gallery-current-index]',
    scrollGallery: '[data-scroll-gallery]',
    scrollGalleryItem: '[data-scroll-gallery-item]',
    scrollGalleryImage: '[data-scroll-gallery-image]',
    initialSlide: '[data-initial-slide]',

    productJson: '[data-product-json]',
    cartJson: '[data-cart-json]',
    singleOptionSelector: '[data-single-option-selector]',
    variantOptionValueList: '[data-variant-option-value-list][data-option-position]',
    variantOptionValue: '[data-variant-option-value]'
  };


  var classes = {
    hide: 'hide',
    variantOptionValueActive: 'is-active',
    zoomReady: 'is-zoomable',
    zoomedIn: 'is-zoomed',
    scrollGalleryReady: 'is-ready',
    scrollGalleryItemActive: 'is-active'
  };

  var $window   = $(window);

  /**
   * ProductDetailForm constructor
   *
   * @param { Object } config
   * @param { jQuery } config.$el - Main element, see snippets/product-detail-form.liquid
   * @param { jQuery } config.$container - Container to listen to scope events / element to listen to events on.  Defaults to config.$el
   * @param { Boolean } config.enableHistoryState - If set to "true", turns on URL updating when switching variants
   * @param { Function } config.onReady -  Called after the product form is initialized.
   */
  function ProductDetailForm(config) {

    this.settings = {};
    this.name = 'productDetailForm';
    this.namespace = '.'+this.name;

    this.events = {
      RESIZE: 'resize' + this.namespace,
      CLICK:  'click'  + this.namespace,
      READY:  'ready'  + this.namespace
    };
    
    var ready = false;
    var options = options || {};
    var defaults = {
      enableHistoryState: true
    };

    this.initialize = function() {
      if(ready) {
        return;
      }

      this.settings = $.extend({}, defaults, config);

      if (!this.settings.$el || this.settings.$el == undefined) {
        console.warn('['+this.name+'] - $el required to initialize');
        return;
      }

      this.$el = this.settings.$el;
      this.$container = this.settings.$container;

      if (!this.$container || this.$container == undefined) {
        this.$container = this.$el;
      }

      // DOM elements we need
      this.$singleOptionSelectors      = $(selectors.singleOptionSelector, this.$container);
      this.$productGallerySlideshow    = $(selectors.productGallerySlideshow, this.$container);
      this.$productGalleryCurrentIndex = $(selectors.productGalleryCurrentIndex, this.$container);
      this.$addToCartBtn               = $(selectors.addToCart, this.$container);
      this.$addToCartBtnText           = $(selectors.addToCartText, this.$container);
      this.$priceWrapper               = $(selectors.priceWrapper, this.$container);
      this.$productPrice               = $(selectors.productPrice, this.$container);
      this.$comparePrice               = $(selectors.comparePrice, this.$container);
      this.$comparePriceText           = $(selectors.comparePriceText, this.$container);
      this.$scrollGallery              = $(selectors.scrollGallery, this.$container);
      this.$scrollGalleryItems         = $(selectors.scrollGalleryItem, this.$container);
      this.$scrollGalleryImages        = $(selectors.scrollGalleryImage, this.$container);

      // Variables we need
      this.transitionDuration = slate.animations.getTransitionTimingDuration('medium');
      this.product            = JSON.parse($(selectors.productJson, this.$container).html());
      this.cart               = JSON.parse($(selectors.cartJson, this.$container).html());

      slate.utils.chosenSelects(this.$container);

      var variantOptions = {
        $container: this.$container,
        enableHistoryState: this.settings.enableHistoryState,
        singleOptionSelector: selectors.singleOptionSelector,
        originalSelectorId: selectors.originalSelectorId,
        product: this.product
      };

      this.variants                        = new slate.Variants(variantOptions);
      this.productImageTouchZoomController = new slate.models.ProductImageTouchZoomController(this.$container);
      this.productImageZoomController      = new slate.models.ProductImageZoomController(this.$container);

      this.productImageZoomController.enable();

      // See slate.Variants
      this.$container.on('variantChange' + this.namespace, this.onVariantChange.bind(this));
      this.$container.on('submit', selectors.addForm, this.onAddFormSubmit.bind(this));
      $window.on('update.ajaxCart', this.onAJAXCartUpdate.bind(this));

      this.initGallery();

      this.$scrollGalleryImages.first().imagesLoaded(function() {
        this.$scrollGallery.addClass(classes.scrollGalleryReady);
      }.bind(this));

      this.$scrollGalleryImages.unveil(200, function() {
        var $img = $(this);
        $img.on('load', function() {
          $img.addClass('is-loaded').removeAttr('data-src');
        });
      });

      // TODO - if window.scrolltop > 100vh, trigger lookup

      this.$container.on(this.events.CLICK, selectors.variantOptionValue, this.onVariantOptionValueClick.bind(this));

      this.$el.trigger( $.Event(this.events.READY) );

      ready = true;
    };

    return this;
  }

  ProductDetailForm.prototype = $.extend({}, ProductDetailForm.prototype, {

    _isProductInCart: function() {
      return this.cart.item_count && $.grep(this.cart.items, function(item) { return item.product_id == this.product.id; }.bind(this)).length;
    },

    _productIsQuantityRestricted: function() {
      return (this.product.tags.map(function(tag) { return tag.toLowerCase().split(' ').join('-'); }).indexOf('quantity-restricted') > -1);
    },

    initGallery: function() {

      var self = this;

      function onSlideshowSlickAfterChange(e, slick) {
        self.$productGalleryCurrentIndex.text( slate.utils.pad(slick.currentSlide + 1, 2, 0) );
      }    

      // Look for element with the initialSlide selector.
      var initialSlide = this.$productGallerySlideshow.find(selectors.initialSlide).length ? this.$productGallerySlideshow.find(selectors.initialSlide).index() : 0;

      this.$productGallerySlideshow.on({
        afterChange: onSlideshowSlickAfterChange
      });

      this.$productGallerySlideshow.slick({
        speed: this.transitionDuration,
        dots: false,
        swipe: Modernizr.touchevents,
        arrows: false,
        initialSlide: initialSlide,
        accessibility: false,
        draggable: true
      });      
    },

    onAJAXCartUpdate: function(e) {
      if(e && e.cart) {
        this.cart = e.cart;
        this.$singleOptionSelectors.first().trigger('change'); // this will cause onVariantChange to trigger
      }
    },

    // In case someone gets around the disabled button and submits the form
    onAddFormSubmit: function(e) {
      if(this._productIsQuantityRestricted() && this._isProductInCart()) {
        e.stopPropagation();
        return false;
      }
    },

    onVariantChange: function(evt) {
      var variant = evt.variant;

      this.updateProductPrices(variant);
      this.updateAddToCartState(variant);
      this.updateVariantOptionValues(variant);
      // this.updateGallery(variant);

      this.$singleOptionSelectors.trigger('chosen:updated');
    },

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {Object} variant - Shopify variant object
     */
    updateAddToCartState: function(variant) {

      if(this._productIsQuantityRestricted() && this._isProductInCart()) {
        this.$addToCartBtn.prop('disabled', true);
        this.$addToCartBtnText.html('Already in cart');
        return;
      }

      if (variant) {
        this.$priceWrapper.removeClass(classes.hide);
      } else {
        this.$addToCartBtn.prop('disabled', true);
        this.$addToCartBtnText.html(theme.strings.unavailable);
        this.$priceWrapper.addClass(classes.hide);
        return;
      }

      if (variant.available) {
        this.$addToCartBtn.prop('disabled', false);
        this.$addToCartBtnText.html(theme.strings.addToCart);
      } else {
        this.$addToCartBtn.prop('disabled', true);
        this.$addToCartBtnText.html(theme.strings.soldOut);
      }
    },   

    /**
     * Updates the DOM with specified prices
     *
     * @param {Object} variant - Shopify variant object
     */
    updateProductPrices: function(variant) {

      var $compareEls   = this.$comparePrice.add( this.$comparePriceText );

      if(variant) {
        this.$productPrice.html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

        if (variant.compare_at_price > variant.price) {
          this.$comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
          $compareEls.removeClass(classes.hide);
        } else {
          this.$comparePrice.html('');
          $compareEls.addClass(classes.hide);
        }
      }
    },

    /**
     * Updates the DOM state of the elements matching the variantOption Value selector based on the currently selected variant
     *
     * @param {Object} variant - Shopify variant object
     */
    updateVariantOptionValues: function(variant) {
      if(variant) {
        // Loop through all the options and update the option value
        for (var i = 3; i >= 1; i--) {
          var variantOptionValue = variant['option' + i];
          // Since we are finding the variantOptionValueUI based on the *actual* value, we need to scope to the correct list
          // As some products can have the same values for different variant options (waist + inseam both use "32", "34", etc..)
          var $variantOptionValueList = $(selectors.variantOptionValueList, this.$container).filter('[data-option-position="'+i+'"]');
          var $variantOptionValueUI = $('[data-variant-option-value="'+variantOptionValue+'"]', $variantOptionValueList);

          $variantOptionValueUI.addClass( classes.variantOptionValueActive );
          $variantOptionValueUI.siblings().removeClass( classes.variantOptionValueActive );
        }
      }
    },

    /**
     * Look for the variant's featured image in the main gallery and switch to that
     *
     * @param {Object} variant - Shopify variant object
     */
    updateGallery: function(variant) {

      if (variant && variant.featured_image && this.$productGallerySlideshow.find('.slick-current').data('image') != variant.featured_image.id) {
        // Slide to featured image for selected variant but only if we're not already on it.
        // Have to check this way because slick clones slides so even if we're currently on it, there can be a cloned slide that also has the correct data-image attribute
        var $imageSlide = this.$productGallerySlideshow.find('[data-image="'+variant.featured_image.id+'"]').first();

        if ($imageSlide.length) {
          this.$productGallerySlideshow.slick('slickGoTo', $imageSlide.data('slick-index'));
        }
      }
    },   

    /**
     * Handle variant option value click event.
     * Update the associated select tag and update the UI for this value
     *
     * @param {event} evt
     */
    onVariantOptionValueClick: function(e) {

      var $option = $(e.currentTarget);

      if ($option.hasClass(classes.variantOptionValueActive)) {
        return;
      }

      var value     = $option.data('variant-option-value');
      var position  = $option.parents(selectors.variantOptionValueList).data('option-position');
      var $selector = this.$singleOptionSelectors.filter('[data-index="option'+position+'"]');

      $selector.val(value);
      $selector.trigger('change');

      $option.addClass(classes.variantOptionValueActive);
      $option.siblings().removeClass(classes.variantOptionValueActive);      

    }
  });

  return ProductDetailForm;

})(jQuery, Modernizr, slate);

/**
 * Quantity Adjuster Scripts
 * -----------------------------------------------------------------------------
 * Handles any events associated with the quantity adjuster component
 *
 *  [data-quantity-adjuster]
 *    [data-increment]
 *    input[type="number"]
 *    [data-decrement]
 *
 */

slate.quantityAdjuster = (function() {

  var selectors = {
    adjuster: '[data-quantity-adjuster]',
    increment: '[data-increment]',
    decrement: '[data-decrement]',
    input: 'input[type="number"]'
  };

  var classes = {

  };

  /**
   * Quantity Adjuster Constructor
   *
   * @param {HTMLElement | jQuery} el - element, either matching selectors.adjuster or a child element
   */
  function QuantityAdjuster(el) {

    this.name = 'quantityAdjuster',
    this.namespace = '.'+this.name;

    this.$el = $(el).is(selectors.adjuster) ? $(el) : $(el).parents(selectors.adjuster);

    if(!this.$el) {
      console.warn('['+this.name+'] - Element required to initialize');
      return;
    }

    this.$increment = $(selectors.increment, this.$el);
    this.$decrement = $(selectors.decrement, this.$el);
    this.$input     = $(selectors.input, this.$el);

    this.$increment.on('click', this.onIncrementClick.bind(this));
    this.$decrement.on('click', this.onDecrementClick.bind(this));
    this.$input.on('change', this.onInputChange.bind(this));

    this._addMutationObserver(this.$input.get(0));

    this._updateDisabledState();
  }

  QuantityAdjuster.prototype = {

    _getMin: function() {
      return parseInt(this.$input.attr('min')) || 0;
    },

    _getMax: function() {
      return parseInt(this.$input.attr('max')) || 999;
    },

    _addMutationObserver: function(el) {
      if(!el) return;

      var observer;
      var config = { attributes: true };
      var self = this;

      observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if(mutation.type == "attributes") {
            if(mutation.attributeName == "max" || mutation.attributeName == "min") {
              self.onMinMaxAttributeChange();
            }
            else if(mutation.attributeName == "disabled") {
              self.onDisabledAttributeChange();
            }
          }
        });
      });

      observer.observe(el, config);
    },

    _updateDisabledState: function() {
      var val = parseInt(this.$input.val());

      if(this.$input.is(':disabled')) {
        this.$increment.prop('disabled', true);
        this.$decrement.prop('disabled', true);
      }
      else {
        if(val >= this._getMax()) {
          this.$increment.prop('disabled', true);
          this.$decrement.prop('disabled', false);
        }
        else if(val <= this._getMin()) {
          this.$increment.prop('disabled', false);
          this.$decrement.prop('disabled', true);
        }
        else {
          this.$increment.prop('disabled', false);
          this.$decrement.prop('disabled', false);
        }
      }
    },

    _changeValue: function(amount) {

      if(this.$input.is(':disabled') || typeof amount == "undefined") return;

      amount = parseInt(amount);
      
      var val = parseInt(this.$input.val());
      var newVal = val + amount;

      // Don't change if the value is the same or invalid
      if(newVal == val || newVal > this._getMax() || newVal < this._getMin()) return;

      this.$input.val(newVal);
      this.$input.trigger('change');
    },

    _clampInputVal: function() {
      var currVal = parseInt(this.$input.val());
      var max = this._getMax();
      var min = this._getMin();

      if(currVal > max) {
        this.$input.val(max);
      }
      else if(currVal < min) {
        this.$input.val(min);
      }
    },

    onDisabledAttributeChange: function() {
      this._updateDisabledState();
    },

    onMinMaxAttributeChange: function() {
      this._clampInputVal();
      this._updateDisabledState();
    },

    onInputChange: function() {
      this._clampInputVal();
      this._updateDisabledState();
    },

    onIncrementClick: function(e) {
      e.preventDefault();
      this._changeValue(1);
    },

    onDecrementClick: function(e) {
      e.preventDefault();
      this._changeValue(-1);
    }
  };

  // End prototype

  // QA DATA-API
  // ===========

  var dataKey = 'quantity-adjuster';

  function ensureQuantityAdjuster(el) {
    var $el =  $(el);

    if(!$el.is(selectors.adjuster)) {
      $el = $el.parents(selectors.adjuster);
    }

    var data = $el.data(dataKey);

    if(!data) {
      $el.data(dataKey, (data = new QuantityAdjuster($el)));
    }

    return data;
  }

  // Check all adjuster elements on the page and initialize them if necessary
  function refresh() {
    $(selectors.adjuster).each(function(i, el) {
      ensureQuantityAdjuster(el);
    });
  }

  $(function() {
    
    refresh();

    $(document)
      .on('shopify:section:load', refresh)
      .on('shopify:section:unload', refresh)
      .on('shopify:section:select', refresh)
      .on('shopify:section:deselect', refresh)
      .on('shopify:section:reorder', refresh)
      .on('shopify:block:select', refresh)
      .on('shopify:block:deselect', refresh);
  });

  return {
    refresh: refresh
  };

}());
/**
 * Forms Scripts
 * -----------------------------------------------------------------------------
 * Handles any events associated with forms on the site
 */

slate.forms = (function($) {

  var selectors = {
    formControl: '.form-control',
    formGroup: '.form-group',
    chosen: '.chosen-container'
  };

  var classes = {
   formGroupIsFocused: 'is-focused',
   formGroupHasError: 'has-error'
  };

  var $body = $(document.body);
 
  var initialized = false;

  function onFormControlFocus(e) {
    var $formControl = $(e.currentTarget);
    var $formGroup   = $formControl.parents(selectors.formGroup);

    $formGroup.addClass(classes.formGroupIsFocused);
  }

  function onFormControlBlur(e) {
    var $formControl = $(e.currentTarget);
    var $formGroup   = $formControl.parents(selectors.formGroup);

    $formGroup.removeClass(classes.formGroupIsFocused);    
  }

  function removeFormControlErrorState(e) {
    var $formControl = $(e.currentTarget);
    var $formGroup   = $formControl.parents(selectors.formGroup);

    $formGroup.removeClass(classes.formGroupHasError);
  }

  function onChosenShowingDropdown(e) {
    onFormControlFocus(e);
  }

  function onChosenHidingDropdown(e) {
    onFormControlBlur(e);
  }

  function initialize() {
    if(initialized) return;

    $body.on('focus', selectors.formControl, onFormControlFocus);
    $body.on('blur',  selectors.formControl, onFormControlBlur);
    $body.on('change keydown', selectors.formControl, removeFormControlErrorState);
    $body.on('chosen:showing_dropdown', selectors.formControl, onChosenShowingDropdown);
    $body.on('chosen:hiding_dropdown', selectors.formControl, onChosenHidingDropdown);

    initialized = true;
    
    return initialized;
  }

  return {
    initialize: initialize
  };

}(jQuery));

/**
 * Model - Dropdown
 * -----------------------------------------------------------------------------
 * Dropdowns are just elements that respond to a visibility class in order to hide and show
 *
 * @namespace models.dropdown
 */

 slate.models = slate.models || {};

 slate.models.Dropdown = (function($) {

  var classes = {
    open: 'is-open',
    forcedOpen: 'is-forced-open'
  };  

  /**
   * Dropdown - Exposes methods for opening and closing the dropdown.  All logic is handled externally
   *
   * @constructor
   * @param {jQuery} $trigger - Element with attributes 'data-dropdown-trigger' and 'data-block'
   */
  function Dropdown($trigger) {
    this.$trigger = $trigger;
    this.$el      = $( this.$trigger.data('dropdown-trigger') );
    this.blockId  = this.$trigger.data('block').toString();
  }

  Dropdown.prototype = {

    isOpen: function() {
      return this.$el.hasClass( classes.open );
    },

    open: function() {
      this.$el.addClass( classes.open );
    },

    close: function() {
      this.$el.removeClass( classes.open );
    },

    /**
     * Dropdown manager doesn't use the forced open class
     * So we can use it in conjunction with the theme editor to ensure dropdowns are open while editing
     */
    forceOpen: function() {
      this.$el.addClass( classes.forcedOpen );
    },

    forceClose: function() {
      this.$el.removeClass( classes.forcedOpen );
    }
        
  };

  return Dropdown;

 }(jQuery));
/**
 * Model - DropdownManager
 * -----------------------------------------------------------------------------
 *
 * Requires:
 *  - slate.models.Dropdown
 *  - slate.utils
 *
 * @namespace models.DropdownManager
 */

 slate.models = slate.models || {};

 slate.models.DropdownManager = (function($) {

  /**
   * DropdownManager - Manages opening / closing of all dropdowns.  Makes sure only one shows at a time.
   *
   * @constructor
   * @param {function} dropdownConstructor
   */
  function DropdownManager() {

    this.closeDropdownTimeout = null;
    this.closeDropdownTimeoutDuration = 80;
    this.dropdowns = [];
    this.activeDropdown = undefined;

    this.events = window.PointerEvent ? {
                  end:   "pointerup",
                  enter: "pointerenter",
                  leave: "pointerleave"
                } : {
                  end: "touchend",
                  enter: "mouseenter",
                  leave: "mouseleave"
                };

  }

  DropdownManager.prototype = {
    register: function($trigger) {
      var dd = new slate.models.Dropdown($trigger);

      // Trigger events - the link that you interact with to display the dropdown
      dd.$trigger.on(this.events.enter,  this.onTriggerMouseEnter.bind(this, dd));
      dd.$trigger.on(this.events.leave,  this.onTriggerMouseLeave.bind(this, dd));
      dd.$trigger.on(this.events.end,    this.onTriggerTouchEnd.bind(this, dd));

      // Dropdown events - what happens when you interact with the dropdown itself
      dd.$el.on(this.events.leave, this.onDropdownMouseLeave.bind(this, dd));
      dd.$el.on(this.events.enter, this.onDropdownMouseEnter.bind(this, dd));
      dd.$el.on(this.events.end,   this.onDropdownTouchEnd.bind(this, dd));

      this.dropdowns.push(dd);
    },    
    getDropdownByBlockId: function(id) {
      return slate.utils.findInstance(this.dropdowns, 'blockId', id);
    },
    onTriggerMouseEnter: function(dd, e) {
      if(e.pointerType != "touch") {
        this.stopCloseTimeout();
        this.openDropdown(dd);
      }
    },
    onTriggerMouseLeave: function(dd, e) {
      if(e.pointerType != "touch") {
        this.startCloseTimeout(dd);
      }
    },
    onTriggerTouchEnd: function(dd, e) {
      e.preventDefault();
      e.stopPropagation();
      this.toggleDropdown(dd);
    },
    onDropdownMouseEnter: function(dd, e) {
      if(e.pointerType != "touch") {
        this.stopCloseTimeout();
      }
    },
    onDropdownMouseLeave: function(dd, e) {
      if(e.pointerType != "touch") {
        this.startCloseTimeout(dd);
      }
    },
    onDropdownTouchEnd: function(dd, e) {
      e.stopPropagation();
    },
    toggleDropdown: function(dd) {
      return this.activeDropdown == dd ? this.closeDropdown(dd) : this.openDropdown(dd);
    },
    openDropdown: function(dd) {
      if(this.activeDropdown !== dd) {
        this.activeDropdown = dd;
        this.closeAllDropdowns();
        dd.open();
      }
    },
    closeDropdown: function(dd) {
      dd.close();

      if(this.activeDropdown == dd) {
        this.activeDropdown = undefined;
      }
    },
    closeAllDropdowns: function() {
      $.each(this.dropdowns, function(i, dd) {
        if(dd.isOpen()) {
          dd.close();
        }
      });
      this.activeDropdown = undefined;
    },
    startCloseTimeout: function(dd) {
      this.closeDropdownTimeout = setTimeout(this.closeDropdown.bind(this, dd), this.closeDropdownTimeoutDuration);
    },
    stopCloseTimeout: function() {
      clearTimeout(this.closeDropdownTimeout);
    }
  };

  return DropdownManager;

 }(jQuery));
/**
 * Drawer
 * ------------------------------------------------------------------------------
 *
 * Requires:
 *  - Modernizr
 *
 * @namespace - models.Drawer
*/

slate.models = slate.models || {};

slate.models.Drawer = (function($, Modernizr) {

  var $document = $(document);
  var $body     = $(document.body);

  var selectors = {
    close: '[data-drawer-close]'
  };

  var classes = {
    drawer: 'drawer',
    visible: 'is-visible',
    backdrop: 'drawer-backdrop',
    backdropVisible: 'is-visible',
    bodyDrawerOpen: 'drawer-open'    
  };

 /**
  * Drawer constructor
  *
  * @param {HTMLElement | $} el - The drawer element
  * @param {Object} options
  */
  function Drawer(el, options) {

    this.name = 'drawer';
    this.namespace = '.'+this.name;

    this.$el = $(el);
    this.$backdrop              = null;
    this.stateIsOpen            = false;
    this.transitionEndEvent     = slate.utils.whichTransitionEnd();
    this.supportsCssTransitions = Modernizr.hasOwnProperty('csstransitions') && Modernizr.csstransitions;

    if(this.$el == undefined || !this.$el.hasClass(classes.drawer)) {
      console.warn('['+this.name+'] - Element with class `'+classes.drawer+'` required to initialize.');
      return;
    }     

    var defaults = {
      closeSelector: selectors.close,
      backdrop: true
    };

    this.settings = $.extend({}, defaults, options);

    this.events = {
      HIDE:   'hide'   + this.namespace,
      HIDDEN: 'hidden' + this.namespace,
      SHOW:   'show'   + this.namespace,
      SHOWN:  'shown'  + this.namespace
    };    

    this.$el.on('click', this.settings.closeSelector, this.onCloseClick.bind(this));

  }

  Drawer.prototype = $.extend({}, Drawer.prototype, {

    addBackdrop: function(callback) {
      var _this = this;
      var cb    = callback || $.noop;

      if(this.stateIsOpen) {
        this.$backdrop = $(document.createElement('div'));

        this.$backdrop.addClass(classes.backdrop)
                      .appendTo($body);

        this.$backdrop.one(this.transitionEndEvent, cb);
        this.$backdrop.one('click', this.hide.bind(this));

        // debug this...
        setTimeout(function() {
          $body.addClass(classes.bodyDrawerOpen);          
          _this.$backdrop.addClass(classes.backdropVisible);
        }, 10);
      }
      else {
        cb();
      }
    },

    removeBackdrop: function(callback) {
      var _this = this;
      var cb    = callback || $.noop;

      if(this.$backdrop) {
        this.$backdrop.one(this.transitionEndEvent, function(){
          _this.$backdrop && _this.$backdrop.remove();
          _this.$backdrop = null;
          cb();
        });

        setTimeout(function() {
          _this.$backdrop.removeClass(classes.backdropVisible);
          $body.removeClass(classes.bodyDrawerOpen);
        }, 10);
      }
      else {
        cb();
      }
    },
    
    /**
     * Called after the closing animation has run
     */    
    onHidden: function() {
      this.stateIsOpen = false;
      var e = $.Event(this.events.HIDDEN);
      this.$el.trigger(e);
    },

    /**
     * Called after the opening animation has run
     */
    onShown: function() {
      var e = $.Event(this.events.SHOWN);
      this.$el.trigger(e);
    },

    hide: function() {
      var e = $.Event(this.events.HIDE);
      this.$el.trigger(e);

      if(!this.stateIsOpen) return;

      this.$el.removeClass(classes.visible);

      if(this.settings.backdrop) {
        this.removeBackdrop();
      }        

      if(this.supportsCssTransitions) {
        this.$el.one(this.transitionEndEvent, this.onHidden.bind(this));
      }
      else {
        this.onHidden();
      }
    },

    show: function() {
      var e = $.Event(this.events.SHOW);
      this.$el.trigger(e);

      if(this.stateIsOpen) return;

      this.stateIsOpen = true;

      this.$el.addClass(classes.visible);

      if(this.settings.backdrop) {
        this.addBackdrop();
      }

      if(this.supportsCssTransitions) {
        this.$el.one(this.transitionEndEvent, this.onShown.bind(this));
      }
      else {
        this.onShown();
      }        
    },

    toggle: function() {
      return this.stateIsOpen ? this.hide() : this.show();
    },

    onCloseClick: function(e) {
      e.preventDefault();
      this.hide();
    }
  });

  // DRAWER DATA-API
  // ===============

  $document.on('click.drawer', '[data-toggle="drawer"]', function (e) {

    var $this   = $(this);
    var $target = $($this.attr('data-target'));
    var options = $.extend($target.data(), $this.data());
    var data    = $this.data('drawer');

    if ($this.is('a')) e.preventDefault();

    if(!data) {
      $this.data('drawer', (data = new Drawer($target, options)));
      data.show();
    }
    else {
      data.toggle();
    }

  });  

  return Drawer;
  
}(jQuery, Modernizr));

/**
 * Slideshow
 * ------------------------------------------------------------------------------
 *
 * Requires:
 *  - slick.min.js
 *  - Modernizr
 *
 * - NOTE: Slideshow wrapper is *not* required to initialize, but it is required if you want to take advantage of the a11y code inside here
 *
 * @namespace - models.Slideshow
*/

slate.models = slate.models || {};

slate.models.Slideshow = (function($, Modernizr) {

  var selectors = {
    slideshowWrapper: '[data-slideshow-wrapper]',
    slideshow: '[data-slideshow]'
  };

  var KEYS = {
    left: 37,
    right: 39
  };

 /**
  * Slideshow constructor
  *
  * @param {HTMLElement | $} el - The actual slideshow element
  * @param {Object} options - Options passed into the slider initialize function
  */
  function Slideshow(el, options) {

    var $el = $(el);

    this.$slideshow = $el;
    this.$wrapper   = $el.closest(selectors.slideShowWrapper);

    if(!this.$slideshow.length){
      console.warn('['+this.name+'] - Slideshow element required to initialize');
      return;
    }

    var fade = this.$slideshow.attr('data-fade') && this.$slideshow.attr('data-fade').length ? this.$slideshow.data('fade') : true; // Allows us to pass data-fade="false".  $.fn.attr coerces to string, $.fn.data does *not*

    var defaults = {
      accessibility: false, // prevents page from jumping on focus
      arrows: !Modernizr.touchevents,
      dots: this.$slideshow.data('dots'),
      fade: fade,
      draggable: true,
      touchThreshold: 20,
      slidesToShow: this.$slideshow.data('slides-to-show') || 1,
      slidesToScroll: this.$slideshow.data('slides-to-scroll') || 1,
      autoplay: this.$slideshow.data('autoplay') || false,
      autoplaySpeed: this.$slideshow.data('speed') || 5000,
      prevArrow: '<div class="slick-arrow slick-arrow--prev"><span class="arrow arrow--left"><span class="arrow__icon"></span></span></div>',
      nextArrow: '<div class="slick-arrow slick-arrow--next"><span class="arrow arrow--right"><span class="arrow__icon"></span></span></div>',

      // Options below here are not used in slick
      equalHeightSlides: this.$slideshow.data('equal-heights') || false
    };

    this.settings = $.extend({}, defaults, options);

    this.$slideshow.on('init', this.slideshowA11y.bind(this));
    this.$slideshow.slick(this.settings);

    if(this.settings.equalHeightSlides) {
      this.$slideshow.addClass('has-equal-height-slides');
    }
  }

  Slideshow.prototype = $.extend({}, Slideshow.prototype, {
   /**
    * Adds events to the slideshow for improved accessibility
    *
    * @param {Event} evt - window event w/ type "init"
    * @param {Object} slick
    */
    slideshowA11y: function(evt, slick) {
      var self     = this;
      var $list    = slick.$list;
      var $dots    = slick.$dots;
      var $wrapper = this.$wrapper;
      var autoplay = this.settings.autoplay;

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused
      // pause slideshow and set aria-live.
      $wrapper.on('focusin', function(evt) {
        if (!$wrapper.has(evt.target).length) {
          return;
        }

        $list.attr('aria-live', 'polite');

        if (autoplay) {
          self.pause();
        }
      });

      // Resume autoplay
      $wrapper.on('focusout', function(evt) {
        if (!$wrapper.has(evt.target).length) {
          return;
        }

        $list.removeAttr('aria-live');

        if (autoplay) {
          self.play();
        }
      });

      // Add arrow key support when focused
      if ($dots) {
        $dots.on('keydown', function(evt) {
          if (evt.which === KEYS.left) {
            self.prev();
          }

          if (evt.which === KEYS.right) {
            self.next();
          }

          // Update focus on newly selected tab
          if ((evt.which === KEYS.left) || (evt.which === KEYS.right)) {
            $dots.find('.slick-active button').focus();
          }
        });
      }
    },

    next: function() {
      this.$slideshow.slick('slickNext');
    },

    prev: function() {
      this.$slideshow.slick('slickPrev');
    },

    pause: function() {
      this.$slideshow.slick('slickPause');
    },

    play: function() {
      this.$slideshow.slick('slickPlay');
    },

    unpause: function() {
      if(this.settings.autoplay) {
        this.play();
      }
    },

   /**
    * Finds and displays a slide associated with the blockId passed in.
    * Note:  Block IDs are not required on slides for the slideshow to work
    *        If used, the slide element must have the attribute - data-block-id="{{ block.id }}"
    *
    * @param {string} blockId
    */
    goToSlideByBlockId: function(blockId) {
      var slick = this.$slideshow.slick('getSlick');
      var $slide = slick.$slides.filter('[data-block-id="' + blockId + '"]:not(.slick-cloned)');
      
      this.$slideshow.slick('slickGoTo', $slide.data('slick-index') );
    }

  });

  return Slideshow;
}(jQuery, Modernizr));

/**
 * Overlay
 * ------------------------------------------------------------------------------
 *
 * Requires:
 *  - Modernizr
 *
 * @namespace - models.Overlay
*/

slate.models = slate.models || {};

slate.models.Overlay = (function($, Modernizr) {

  var $document = $(document);
  var $body     = $(document.body);

  var selectors = {
    close: '[data-overlay-close]'
  };

  var classes = {
    overlay: 'overlay',
    visible: 'is-visible',
    bodyOverlayOpen: 'overlay-open'
  };

 /**
  * Overlay constructor
  *
  * @param {HTMLElement | $} el - The overlay element
  * @param {Object} options
  */
  function Overlay(el, options) {

    this.name = 'overlay';
    this.namespace = '.'+this.name;

    this.$el      = $(el);

    this.stateIsOpen            = false;
    this.transitionEndEvent     = slate.utils.whichTransitionEnd();    
    this.supportsCssTransitions = Modernizr.hasOwnProperty('csstransitions') && Modernizr.csstransitions;

    if (this.$el == undefined || !this.$el.hasClass(classes.overlay)) {
      console.warn('['+this.name+'] - Element with class `'+classes.overlay+'` required to initialize.');
      return;
    }    

    var defaults = {
      closeSelector: selectors.close
    };

    this.settings = $.extend({}, defaults, options);

    this.events = {
      HIDE:   'hide'   + this.namespace,
      HIDDEN: 'hidden' + this.namespace,
      SHOW:   'show'   + this.namespace,
      SHOWN:  'shown'  + this.namespace,
      FOCUS:  'focus'  + this.namespace,
      KEYDOWN_DISMISS: 'keydown.dismiss' + this.namespace
    };    

    this.$el.on('click', this.settings.closeSelector, this.onCloseClick.bind(this));

  }

  Overlay.prototype = $.extend({}, Overlay.prototype, {
    
    /**
     * Called after the closing animation has run
     */    
    onHidden: function() {
      $body.removeClass(classes.bodyOverlayOpen);

      var e = $.Event(this.events.HIDDEN);
      this.$el.trigger(e);
    },

    /**
     * Called after the opening animation has run
     */
    onShown: function() {
      this.enforceFocus();

      var e = $.Event(this.events.SHOWN);
      this.$el.trigger(e);
      this.$el.trigger('focus');
    },

    hide: function() {
      var e = $.Event(this.events.HIDE);
      this.$el.trigger(e);

      if(!this.stateIsOpen) return;

      this.stateIsOpen = false;

      this.updateEscapeHandler();

      $document.off(this.events.FOCUS);

      this.$el.removeClass(classes.visible);      

      if(this.supportsCssTransitions) {
        this.$el.one(this.transitionEndEvent, this.onHidden.bind(this));
      }
      else {
        this.onHidden();
      }
    },

    show: function() {
      var e = $.Event(this.events.SHOW);
      this.$el.trigger(e);

      if(this.stateIsOpen) return;

      this.stateIsOpen = true;

      this.updateEscapeHandler();

      $body.addClass(classes.bodyOverlayOpen);
      this.$el.addClass(classes.visible);

      if(this.supportsCssTransitions) {      
        this.$el.one(this.transitionEndEvent, this.onShown.bind(this));
      }
      else {
        this.onShown();
      }
    },

    enforceFocus: function() {
      $document.off(this.events.FOCUS);
      $document.on(this.events.FOCUS, $.proxy(function(e) {
        if (document !== e.target && this.$element[0] !== e.target && !this.$element.has(e.target).length) {
          this.$el.trigger('focus');
        }
      }, this));
    },

    updateEscapeHandler: function() {
      if(this.stateIsOpen) {
        this.$el.on(this.events.KEYDOWN_DISMISS, $.proxy(function(e) {
          e.which == 27 && this.hide();
        }, this));
      }
      else {
        this.$el.off(this.events.KEYDOWN_DISMISS);
      }
    },

    toggle: function() {
      return this.stateIsOpen ? this.hide() : this.show();
    },    

    onCloseClick: function(e) {
      e.preventDefault();
      this.hide();
    }
  });

  // OVERLAY DATA-API
  // ===============

  $document.on('click.overlay', '[data-toggle="overlay"]', function (e) {

    var $this   = $(this);
    var $target = $($this.attr('data-target'));
    var options = $.extend($target.data(), $this.data());
    var data    = $this.data('overlay');

    if ($this.is('a')) e.preventDefault();

    if(!data) {
      $this.data('overlay', (data = new Overlay($target, options)));
      data.show();
    }
    else {
      data.toggle();
    }

  });   

  return Overlay;
}(jQuery, Modernizr));

/**
 * Model - Collection Sort
 * ------------------------------------------------------------------------------
 *
 * Dependencies
 *  - slate.utils
 *
 * @namespace - models.collectionSort
 */

 slate.models.CollectionSort = (function(){

  var $body = $(document.body);
  
  var selectors = {
    sortSelect: '[data-sort-select]'
  };

  /**
   * CollectionSort constructor
   *
   * @param {HTMLElement} container - Container element used for scoping any element selection
   * @param {Object} collectionData - see the bottom of `sections/collection.liquid`
   */
  function CollectionSort(container, collectionData) {
    this.$container = $(container);

    this.name = 'collectionSort';
    this.namespace = '.'+this.name;

    // Stop parsing if we don't have the collection data
    if (!collectionData) {
      return;
    }

    this.collectionData = collectionData;

    this.$container.on('change', selectors.sortSelect, this.applySort.bind(this));
  }

  CollectionSort.prototype = $.extend({}, CollectionSort.prototype, {
    applySort: function() {
      var sortBy = $(selectors.sortSelect, this.container).find('option:selected').val();
      var queryParams = slate.utils.getQueryParams();

      if(sortBy !== this.collectionData.sortDefault) {
        queryParams.sort_by = sortBy;
      }
      else {
        delete queryParams.sort_by;
      }

      location.search = $.param(queryParams);
    }
  });

  return CollectionSort;
})();
/**
 * Model - Product Image Touch Zoom Controller
 * -----------------------------------------------------------------------------
 *
 * @namespace models.productImageTouchZoomController
 */

 slate.models = slate.models || {};

 slate.models.ProductImageTouchZoomController = (function($) {

  var selectors = {
    gallerySlideLink: '[data-product-gallery-slide-link]', // href="{{ zoom_url }}"
    blowup: '[data-product-blowup]',
    blowupScroll: '[data-product-blowup-scroll]',
    blowupImage: '[data-product-blowup-image]'
  };

  var classes = {
    bodyBlowupOpen: 'product-blowup-open',
    blowupActive: 'is-active'
  };

  var $window = $(window);
  var $body = $(document.body);

  /**
   * ProductImageTouchZoomController
   *
   * @constructor
   * @param {jQuery} $el - element containing all required elements
   */
  function ProductImageTouchZoomController($el) {
    this.name = 'productImageTouchZoomController';
    this.namespace = '.'+this.name;

    this.$container = $el;

    if(!$el) {
      console.warn('['+this.name+'] - $el required to initialize');
      return;
    }
    
    this.isZoomed = false;
    this.scrollInstance = undefined;

    this.$productBlowup = $(selectors.blowup, this.$container);
    this.$productBlowupScroll = $(selectors.blowupScroll, this.$container);
    this.$productBlowupImage = $(selectors.blowupImage, this.$container);

    this.$container.on('click', selectors.gallerySlideLink, this.onGallerySlideLinkClick.bind(this));
    this.$container.on('click tap', selectors.blowup, this.onBlowupClick.bind(this)); // See iscroll init for tap event
  }

  ProductImageTouchZoomController.prototype = {
    
    zoomIn: function(src, zoomSrc) {
      if(this.zoomedIn) return;

      var self = this;
      var $zoomImg = $(new Image());

      var winHeight = $window.height();
      var winWidth  = $window.width();
  
      this.scrollInstance = new IScroll(this.$productBlowupScroll.get(0), {
        zoom: true,
        hideScrollbar: true,
        scrollX: true,
        scrollY: true,
        // freeScroll: true,
        zoomMin: 0.8,
        zoomMax: 1.5,
        startZoom: 1,
        directionLockThreshold: 20,
        tap: true,
        click: true
      });

      // Set the small src on it
      this.$productBlowupImage.on('load', function () {
        console.log('w = ' + this.$productBlowupImage.outerWidth());
        console.log('h = ' + this.$productBlowupImage.outerHeight());

        var x = -1 * ((this.$productBlowupImage.width() - winWidth)/2);
        var y = -1 * ((this.$productBlowupImage.height() - winHeight)/2);
        this.scrollInstance.scrollTo(x, y, 0);
      }.bind(this));

      this.$productBlowupImage.attr('src', src);      

      // Load up the big image
      if(zoomSrc) {
        $zoomImg.on('load', function() {
          self.$productBlowupImage.attr('src', zoomSrc);
        }).attr('src', zoomSrc);
      }

      $body.addClass(classes.bodyBlowupOpen);
      this.$productBlowup.addClass(classes.blowupActive);
      this.zoomedIn = true;
    },

    zoomOut: function() {
      if(!this.zoomedIn) return;

      if(this.scrollInstance instanceof IScroll) {
        this.scrollInstance.destroy();
      }

      $body.removeClass(classes.bodyBlowupOpen);
      this.$productBlowup.removeClass(classes.blowupActive);
      this.zoomedIn = false;
    },

    onGallerySlideLinkClick: function(e) {
      e.preventDefault();

      var $slide = $(e.currentTarget);

      this.zoomIn($slide.find('img').attr('src'), $slide.attr('href'));
    },

    onBlowupClick: function(e) {
      this.zoomOut();
    }
  };

  return ProductImageTouchZoomController;

 }(jQuery));

/**
 * Model - Product Image Zoom Controller
 * -----------------------------------------------------------------------------
 *
 * @namespace models.productImageZoomController
 */

 slate.models = slate.models || {};

 slate.models.ProductImageZoomController = (function($, Hammer, Modernizr) {

  var selectors = {
    image: '[data-scroll-gallery-image]'
  };

  var classes = {
    zoomTarget: 'product-zoom-target',
    zoomTargetIsActive: 'is-active',
    zoom: 'product-zoom',
    zoomIsActive: 'is-active'
  };

  var $body = $(document.body);

  /**
   * ProductImageZoomController
   *
   * @constructor
   * @param {jQuery} $el - element containing all required elements
   */
  function ProductImageZoomController($el) {
    this.name = 'productImageZoomController';
    this.namespace = '.'+this.name;

    this.touch = Modernizr.touchevents;
    this.hammerInstances = [];
    this.enabled = false;
    this.isZoomed = false;
    this.supportsTransitions = Modernizr.csstransitions;
    this.transitionEndEvent = slate.utils.whichTransitionEnd();
    this.transformProperty = Modernizr.prefixed('transform') || 'transform';
    this.events = {
      MOUSEENTER:  'mouseenter' + this.namespace,
      MOUSELEAVE: 'mouseleave' + this.namespace,
      CLICK:  'click' + this.namespace
    };    

    this.$container = $el;

    if(!$el) {
      console.warn('['+this.name+'] - $el required to initialize');
      return;
    }

    this.$target = $(document.createElement('div')).addClass(classes.zoomTarget);
    this.$zoom   = $(document.createElement('div')).addClass(classes.zoom);

    this.$zoom.appendTo($body);
  }

  ProductImageZoomController.prototype = {

    enable: function() {
      if(this.enabled) return;

      var self = this;

      if(this.touch) {
        this.hammerInstances = $.map( $(selectors.image), function(img) {
          
          var $img     = $(img);
          var instance = new Hammer(img);
          var press    = new Hammer.Press({
                               time: 300
                             });

          instance.add(press);
          instance.on('press', function(e) { self.onPress(e, $img, instance);});

          return instance;
        });
      }
      else {
        this.$container.on(this.events.MOUSEENTER, selectors.image, this.onImageMouseEnter.bind(this));
        this.$container.on(this.events.MOUSELEAVE, selectors.image, this.onImageMouseLeave.bind(this));
        this.$container.on(this.events.CLICK, selectors.image, this.onImageClick.bind(this));        
      }

      this.enabled = true; 
    },

    disable: function() {
      if(!this.enabled) return;

      if(this.touch && this.hammerInstances.length) {
        this.hammerInstances.forEach(function(instance) { instance.off('pan panstart panend press pressup'); });
        this.hammerInstances.length = 0;
      }
      else {
        this.$container.off(this.events.MOUSEENTER);
        this.$container.off(this.events.MOUSELEAVE);
        this.$container.off(this.events.CLICK);        
      }

      this.enabled = false;
    },

    onPointerMoveEvent: function(e, $el, targetHeight, targetWidth) {
      var off = $el.offset();
      var x = Math.floor(e.pageX - off.left);
      var y = Math.floor(e.pageY - off.top);
      var targetX = x - targetWidth/2;
      var targetY = y - targetHeight/2;
      var positionX = parseFloat( ((x / $el.width()) * 100).toFixed(2) );
      var positionY = parseFloat( ((y / $el.height()) * 100).toFixed(2) );

      // Clamp values (0 -> 100)
      positionX = Math.min(Math.max(0, positionX), 100);
      positionY = Math.min(Math.max(0, positionY), 100);

      window.requestAnimationFrame(function() {
        this.$target.css(this.transformProperty, 'translate(' + targetX + 'px, ' + targetY + 'px)');
        this.isZoomed && this.$zoom.css('background-position', positionX + '% ' + positionY + '%');  
      }.bind(this));
    },

    // Equivalent of attachMouseHandler for touch
    onPress: function(e, $el, instance) {
      var self = this;

      this.$target.remove().insertAfter($el);
      this.$target.show();

      var targetWidth  = this.$target.width();
      var targetHeight = this.$target.height();      

      instance.on('panstart', function(e) {
        $body.css('overflow', 'hidden');
        self.$target.remove().insertAfter($el);
        self.$target.show();
      });

      instance.on('panend',   function(e) {
        $body.css('overflow', '');
        self.$target.remove();
        self.$target.hide();   
        instance.off('pan panstart panend');
        self.zoomOut();
      });      

      instance.on('pan', function(e) {   
        self.onPointerMoveEvent(e.srcEvent, $el, targetHeight, targetWidth);
      });

      self.zoomIn($el, e.srcEvent);
    },

    attachMouseHandler: function($el) {
      var self = this;

      this.$target.remove().insertAfter($el);
      this.$target.show();

      var targetWidth = this.$target.width();
      var targetHeight = this.$target.height();

      $el.css('cursor', 'none');
      $el.on('mousemove', function(e) {
        self.onPointerMoveEvent(e, $el, targetHeight, targetWidth);
      });
    },

    removeMouseHandler: function($el) {
      $el.css('cursor', '');
      $el.off('mousemove');
      this.$target.remove();
      this.$target.hide();
    },    

    zoomOut: function() {
      this.$zoom.removeClass(classes.zoomIsActive);
      this.$target.removeClass(classes.zoomTargetIsActive);
      if(this.supportsTransitions) {
        this.$zoom.one(this.transitionEndEvent, function() {
          this.$zoom.css('background-image', '');
          this.isZoomed = false;          
        }.bind(this));
      }
      else {
        this.$zoom.css('background-image', '');
        this.isZoomed = false;
      }
    },

    zoomIn: function($img, e) {
      this.$zoom.css('background-image', 'url(' + $img.attr('src') + ')');
      this.$zoom.addClass(classes.zoomIsActive);      
      this.$target.addClass(classes.zoomTargetIsActive);
      e && this.onPointerMoveEvent(e, $img, this.$target.height(), this.$target.width());      
      this.isZoomed = true;
    },

    onImageClick: function(e) {
      this.isZoomed ? this.zoomOut() : this.zoomIn($(e.currentTarget), e);
    },

    onImageMouseEnter: function(e) {
      this.attachMouseHandler($(e.currentTarget));
    },

    onImageMouseLeave: function(e) {
      this.removeMouseHandler($(e.currentTarget));
      this.isZoomed && this.zoomOut();
    }
  };

  return ProductImageZoomController;

 }(jQuery, Hammer, Modernizr));

/**
 * Video Cover
 * -----------------------------------------------------------------------------
 * Background videos - woohoo!
 * Right now this only supports Vimeo videos and uses their javascript API to control playback
 *
 */

slate.models = slate.models || {};

slate.models.VideoCover = (function($, Vimeo) {

  var selectors = {
    videoCover: '.video-cover[data-vimeo-id]'
  };

  var classes = {
    playerLoaded: 'is-loaded',
  }; 

  var uniqueIdCount = 0;
  var $document = $(document);
  var $window   = $(window);


 /**
  * Video Cover constructor
  *
  * @param {HTMLElement | $} el - The actual slideshow element
  */
  function VideoCover($el) {
    
    var self = this;
    
    this.$el = $el;

    // Check if we've already made a player for this $el or we're on a mobile device
    if(this.$el.children('iframe').length != 0 || /iPhone|iPod/.test(navigator.platform)) return;

    var name = 'videoCover';
    var namespace = '.' + name;
    var baseClass = 'video-cover';

    var events = {
      RESIZE: 'resize' + namespace,
      READY: 'ready' + namespace
    };     

    var postResizeTimeout;
    var vimeoId   = this.$el.data('vimeo-id');
    var uniqueId  = baseClass + '-' + vimeoId + '-' + uniqueIdCount++; // Construct a unique ID to use on the element

    this.$el.attr('id', uniqueId);
    
    this.player = new Vimeo.Player(uniqueId, {
      id: vimeoId,
      loop: true,
      background: 1
    });

    this.player.on('loaded', function() {
      self.setSize();
      // self.$el.addClass(classes.playerLoaded);
      this.play().then(function() {
        setTimeout(function() {
          self.$el.trigger( $.Event(events.READY) );
          self.$el.addClass(classes.playerLoaded);
        }, 20);
        // self.$el.addClass(classes.playerLoaded);
      });
    });

    $window.on(events.RESIZE, $.throttle(50, function() {
      self.setSize();
      clearTimeout(postResizeTimeout);
      postResizeTimeout = setTimeout(self.setSize.bind(self), 50); // Hit this one time *after* we're done with window resize events to make sure everything is good
    }));
  }

  VideoCover.prototype = $.extend({}, VideoCover.prototype, {
    // See http://codetheory.in/html5-fullscreen-background-video/ for more info on how this works
    // Resizes the video to make sure it fills the container    
    setSize: function() {
      var $video = this.$el.find('iframe');
   
      var w = parseInt($video.attr('width')).toFixed(2);
      var h = parseInt($video.attr('height')).toFixed(2);
       
      var videoRatio = (w / h).toFixed(2);
       
      var minW = this.$el.outerWidth();
      var minH = this.$el.outerHeight();
       
      var widthRatio  = minW / w;
      var heightRatio = minH / h;
       
      if (widthRatio > heightRatio) {
        var newWidth = minW;
        var newHeight = Math.ceil( newWidth / videoRatio );
      }
      else {
        var newHeight = minH;
        var newWidth = Math.ceil( newHeight * videoRatio );
      }

      var leftMarginToCenter = (minW - newWidth) / 2;
      var topMarginToCenter = (minH - newHeight) / 2;

      $video.css({
        'height': newHeight,
        'width' : newWidth,
        'margin-left': leftMarginToCenter,
        'margin-top' : topMarginToCenter
      });
    },

    play: function() {
      this.player.play();
    },

    pause: function() {
      this.player.pause();
    }
  });

  return VideoCover;

}(jQuery, Vimeo));

/**
 * Slideup
 * ------------------------------------------------------------------------------
 *
 * Requires:
 *  - Modernizr
 *
 * @namespace - models.Slideup
*/

slate.models = slate.models || {};

slate.models.Slideup = (function($, Modernizr) {

  var $document = $(document);

  var selectors = {
    close: '[data-slideup-close]',
  };

  var classes = {
    slideup: 'slideup',
    visible: 'is-visible'
  };

 /**
  * Slideup constructor
  *
  * @param {HTMLElement | $} el - The slideup element
  * @param {Object} options
  */
  function Slideup(el, options) {

    this.name = 'slideup';
    this.namespace = '.'+this.name;

    this.$el = $(el);
    this.stateIsOpen            = false;
    this.transitionEndEvent     = slate.utils.whichTransitionEnd();    
    this.supportsCssTransitions = Modernizr.hasOwnProperty('csstransitions') && Modernizr.csstransitions;


    if (this.$el == undefined || !this.$el.hasClass(classes.slideup)) {
      console.warn('['+this.name+'] - Element with class `'+classes.slideup+'` required to initialize.');
      return;
    }    

    var defaults = {
      closeSelector: selectors.close
    };

    this.settings = $.extend({}, defaults, options);

    this.events = {
      HIDE:   'hide'   + this.namespace,
      HIDDEN: 'hidden' + this.namespace,
      SHOW:   'show'   + this.namespace,
      SHOWN:  'shown'  + this.namespace
    };    

    this.$el.on('click', this.settings.closeSelector, this.onCloseClick.bind(this));

  }

  Slideup.prototype = $.extend({}, Slideup.prototype, {
    
    /**
     * Called after the closing animation has run
     */    
    onHidden: function() {
      var e = $.Event(this.events.HIDDEN);
      this.$el.trigger(e);
    },

    /**
     * Called after the opening animation has run
     */
    onShown: function() {
      var e = $.Event(this.events.SHOWN);
      this.$el.trigger(e);
    },

    hide: function() {
      var e = $.Event(this.events.HIDE);
      this.$el.trigger(e);

      if(!this.stateIsOpen) return;

      this.stateIsOpen = false;

      this.$el.removeClass(classes.visible);

      if(this.supportsCssTransitions) {
        this.$el.one(this.transitionEndEvent, this.onHidden.bind(this));
      }
      else {
        this.onHidden();
      }
    },

    show: function() {
      var e = $.Event(this.events.SHOW);
      this.$el.trigger(e);

      if(this.stateIsOpen) return;

      this.stateIsOpen = true;

      this.$el.addClass(classes.visible);

      if(this.supportsCssTransitions) {
        this.$el.one(this.transitionEndEvent, this.onShown.bind(this));
      }
      else {
        this.onShown();
      }
    },

    toggle: function() {
      return this.stateIsOpen ? this.hide() : this.show();
    },    

    onCloseClick: function(e) {
      e.preventDefault();
      this.hide();
    }
  });

  // SLIDEUP DATA-API
  // ===============

  $document.on('click.slideup', '[data-toggle="slideup"]', function (e) {

    var $this   = $(this);
    var $target = $($this.attr('data-target'));
    var options = $.extend($target.data(), $this.data());
    var data    = $this.data('slideup');

    if ($this.is('a')) e.preventDefault();

    if(!data) {
      $this.data('slideup', (data = new Slideup($target, options)));
      data.show();
    }
    else {
      data.toggle();
    }

  });   

  return Slideup;
}(jQuery, Modernizr));

/**
 * Slideup Alert
 * ------------------------------------------------------------------------------
 *
 * Requires:
 *  - snippets/slideup-template.liquid
 *
 * @namespace - models.SlideupAlert
*/

slate.models = slate.models || {};

slate.models.SlideupAlert = (function($) {

  var $body = $(document.body);

  var selectors = {
    template: 'script[data-slideup-template]'
  };  

 /**
  * Slideup Alert constructor
  *
  * @param {Object} options
  * @param {String} options.text - Body text of the slideup
  * @param {Integer} options.timeoutDuration - How long to display the alert before closing automatically (in ms)
  */
  function SlideupAlert(options) {

    this.name = 'slideupAlert';
    this.namespace = '.'+this.name;

    if(!$(selectors.template).length){
      console.warn('['+this.name+'] - Handlebars template required to initialize');
      return;
    }

    var template = Handlebars.compile($(selectors.template).html());
    var defaults = {
      title: null,
      text: null,
      timeoutDuration: 5000
    };
    
    this.settings = $.extend({}, defaults, options);
    this.interactionTimeout = false;

    this.$el = $(template(this.settings));

    this.$el.appendTo($body);

    this.$el.on('shown.slideup', this.onShown.bind(this));
    this.$el.on('hidden.slideup', this.onHidden.bind(this));
    this.$el.on('mouseenter', this.onMouseenter.bind(this));
    this.$el.on('mouseleave', this.onMouseleave.bind(this));
    this.$el.on('click', this.onClick.bind(this));   

    this.slideup = new slate.models.Slideup(this.$el);

    setTimeout(function() {
      this.slideup.show();
    }.bind(this), 10);

  }

  SlideupAlert.prototype = $.extend({}, SlideupAlert.prototype, {
    
    setInteractionTimeout: function() {
      this.interactionTimeout = setTimeout(function() {
        this.slideup.hide();
      }.bind(this), this.settings.timeoutDuration);
    },

    clearInteractionTimeout: function() {
      clearTimeout(this.interactionTimeout);
    },

    onMouseenter: function() {
      this.clearInteractionTimeout();
    },

    onMouseleave: function() {
      this.setInteractionTimeout();
    },

    onClick: function() {
      this.slideup.hide();
    },

    onHidden: function() {
      this.clearInteractionTimeout();
      this.$el.remove();
    },

    onShown: function() {
      this.setInteractionTimeout();
    }

  });

  return SlideupAlert;
}(jQuery));


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 * Uses slate.productDetailForm to handle core product form functionality.
 *
 * - Attaches the `Product` constructor to window.theme.Product.
 *
 * Requires:
 *  - jQuery
 *  - Slate
 *
 * See:
 * - product.liquid
 * - product-detail-form.liquid
 *
 * @namespace product
 */

theme.Product = (function($, slate) {

  var selectors = {
    productEssential: '[data-product-essential]',
    productScrollContainer: '[data-product-scroll-container]',
    detailsLink: '[data-product-details-link]',
    details: '[data-product-details]'
  };

  var classes = {

  };
  
  var $window   = $(window);
  var $document = $(document);

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    this.settings = {};
    this.name = 'product';
    this.namespace = '.'+this.name;

    this.events = {
      RESIZE: 'resize'  + this.namespace,
      CLICK: 'click'   + this.namespace,
      SCROLL: 'scroll' + this.namespace
    };

    this.stickyScrollBpMin = slate.breakpoints.getBreakpointMinWidth('md');

    var productDetailForm = new slate.ProductDetailForm({
      $el: this.$container,
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
    });

    this.$productEssential = $(selectors.productEssential, this.$container);
    this.$productScrollContainer = $(selectors.productScrollContainer, this.$container);
    this.$details = $(selectors.details, this.$container);
    this.$detailsLink = $(selectors.detailsLink, this.$container);

    productDetailForm.initialize();

    this.$detailsLink.on(this.events.CLICK, this.onDetailsLinkClick.bind(this));
    $window.on('breakpointChange', this.onBreakpointChange.bind(this));

    // hit these one time on init to make sure everything is good
    this.onBreakpointChange();
  }

  Product.prototype = $.extend({}, Product.prototype, {

    onBreakpointChange: function() {
      return $window.width() > this.stickyScrollBpMin ? this.addScrollHandler() : this.removeScrollHandler();
    },

    addScrollHandler: function() {
      this.isFixed = this.$productEssential.css('position') == "fixed";
      this.onScroll();
      $window.on(this.events.SCROLL, $.throttle(20, this.onScroll.bind(this)));
    },

    removeScrollHandler: function() {
      this.$productEssential.css({
        position: '',
        top: ''
      });
    },

    resetScrollElements: function() {
      this.$productEssential.css({
        position: '',
        top: ''
      });
    },

    onDetailsLinkClick: function(e) {
      e.preventDefault();
      
      var speed = 1.8; // to keep things consistent as scroll from different offsets.  Normalized to calculate to ms
      var offset;
      var distance;
      var duration = 1500;

      if(this.$details.length) {
        offset = this.$details.offset()['top'] - 200;
        distance = Math.abs($window.scrollTop() - offset);
        if( (distance / speed) < duration) {
          duration = distance / speed;
        }

        $("html, body").animate({ scrollTop: (offset + 'px') }, {
          duration: duration,
          easing: 'easeInOutQuart'
        });
      }
    },   

    onScroll: function(e) {
      if(window.innerWidth < this.stickyScrollBpMin) return;

      var essentialOffset = this.$productEssential.offset();
      var essentialOuterHeight = Math.round(this.$productEssential.outerHeight());      
      var essentialTopOffset = essentialOffset['top']
      var essentialBottomOffset = Math.round(essentialTopOffset + essentialOuterHeight);
      var scrollContainerBottomOffset = Math.round(this.$productScrollContainer.offset()['top'] + this.$productScrollContainer.outerHeight());
      var onAF; // onAnimationFrame callback to change style

      if(this.isFixed) {
        if(essentialBottomOffset >= scrollContainerBottomOffset) {
          onAF = function() {
            this.$productEssential.css({
              position: 'absolute',
              top: (scrollContainerBottomOffset - (essentialOuterHeight/2))
            });
            this.isFixed = false;
          };
        }  
      }
      else {

        if(($window.scrollTop() + window.innerHeight/2) < (essentialTopOffset + essentialOuterHeight/2)) {
          onAF = function() {
            this.$productEssential.css({
              position: 'fixed',
              top: ''
            });          
            this.isFixed = true;
          };          
        }
      }

      typeof onAF == "function" && window.requestAnimationFrame(onAF.bind(this));
    },

    onResize: function() {
      this.onScroll();
    }    
  });

  return Product;
})(jQuery, slate);

/**
 * Collection Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Collection template.
 *
 * @namespace collection
 */

 theme.Collection = (function(slate) {

  var selectors = {
    collectionJson: '[data-collection-json]'
  };
  
  function Collection(container) {
    this.$container = $(container);

    this.name = 'collection';
    this.namespace = '.'+this.name;

    // Stop parsing if we don't have the collection json script tag
    if (!$(selectors.collectionJson, this.$container).html()) {
      console.warn('['+this.name+'] - Element matching ' + selectors.collectionJson + ' required.');
      return;
    }

    this.collectionData = JSON.parse($(selectors.collectionJson, this.$container).html());

    this.sort = new slate.models.CollectionSort( container, this.collectionData );

  }

  Collection.prototype = $.extend({}, Collection.prototype, {

  });

  return Collection;

 })(slate);
 
/**
 * Slideshow Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - Slideshow
 */

theme.Slideshow = (function($) {

  var selectors = {
    slideshow: '[data-slideshow]',
  };

  var classes = {

  };
  
  /**
   * Slideshow section constructor
   *
   * @param {string} container - selector for the section container DOM element
   */
  function Slideshow(container) {
    this.$container = $(container);

    this.name = 'slideshow';
    this.namespace = '.'+this.name;

    var settings = {
      // Put your settings here
    };

    this.slideshow = new slate.models.Slideshow( $(selectors.slideshow, this.$container), settings);

  }

  Slideshow.prototype = $.extend({}, Slideshow.prototype, {
    /**
     * Theme Editor section events below
     */
    onBlockSelect: function(evt) {
      this.slideshow.goToSlideByBlockId( evt.detail.blockId );
      this.slideshow.pause();
    }
  });

  return Slideshow;
})(jQuery);

/**
 * Header Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - header
 */

theme.Header = (function($) {

  var $window = $(window);
  var $body   = $(document.body);

  var selectors = {
    header: '[data-header]',
    dropdownTrigger: '[data-dropdown-trigger][data-block]',
  };

  var classes = {
    headerFixed: 'is-fixed',
    siteHasFixedHeader: 'site-fixed-header'
  };

  function Header(container) {

    var _this = this;

    this.$container = $(container);
    this.$el = $(selectors.header, this.$container);
    this.name = 'header';
    this.namespace = '.'+this.name;
    this.dropdownManager = new slate.models.DropdownManager();

    this.events = {
      SCROLL: 'scroll' + this.namespace
    };    

    // Register each dropdown trigger
    $(selectors.dropdownTrigger, this.$container).each(function(i, trigger) {
      _this.dropdownManager.register( $(trigger) );
    });

    this.$container.on('pointerenter mouseenter', this.onMouseEnter.bind(this));
    this.$container.on('pointerleave mouseleave', this.onMouseLeave.bind(this));

    // We pass in the fixed behavior as a class on the body of the site
    if($body.hasClass(classes.siteHasFixedHeader)) {
      $window.on(this.events.SCROLL, $.throttle(20, this.onScroll.bind(this)));
      this.onScroll(); // hit this one time on init to make sure everything is good 
    }

  }

  Header.prototype = $.extend({}, Header.prototype, {

    scrollCheck: function() {
      // Do measurements outside of rAF.
      var scrollTop = $window.scrollTop();
      var actualOffset = this.$container.offset()['top'] - this.$el.outerHeight();

      // Do DOM updates inside.
      requestAnimationFrame(function() {
        if( scrollTop < actualOffset ){
          this.$el.removeClass( classes.headerFixed );
        }
        else {
          this.$el.addClass( classes.headerFixed );
        }
      }.bind(this));

    },    

    onScroll: function() {
      this.scrollCheck();
    },    

    onMouseEnter: function() {

    },

    onMouseLeave: function() {
      this.dropdownManager.closeAllDropdowns();
    },    

    /**
     * Theme Editor section events below
     */

    onBlockSelect: function(e) {
      var dropdown = this.dropdownManager.getDropdownByBlockId( e.detail.blockId );

      // Bypass dropdown manager since we're inside the theme editor
      if(dropdown) {
        dropdown.forceOpen();
      }
    },

    onBlockDeselect: function(e) {
      var dropdown = this.dropdownManager.getDropdownByBlockId( e.detail.blockId );

      // Bypass dropdown manager since we're inside the theme editor
      if(dropdown) {
        dropdown.forceClose();
      }
    }    
  });

  return Header;
})(jQuery);

/**
 * Footer Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - footer
 */

theme.Footer = (function($) {

  var selectors = {

  };

  var classes = {

  };

  function Footer(container) {

    this.$container = $(container);

    this.name = 'footer';
    this.namespace = '.'+this.name;

  }

  Footer.prototype = $.extend({}, Footer.prototype, {

  });

  return Footer;
})(jQuery);

/**
 * Ajax Cart Section Script
 * ------------------------------------------------------------------------------
 * Exposes methods and events for the interacting with the ajax cart section.
 * All logic is handled in slate.AjaxCart, this file is strictly for handling section settings and them editor interactions
 *
 * @namespace - ajaxCart
 */

theme.AjaxCart = (function($) {

  var $body = $(document.body);

  /**
   * AjaxCart section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   *
   * @param {string} container - selector for the section container DOM element
   */
  function AjaxCart(container) {
    this.$container = $(container);

    this.name = 'ajaxCart',
    this.namespace = '.'+this.name;

    this.ajaxCart = new slate.AjaxCart();

    if (!$body.hasClass('template-cart')) {
      this.ajaxCart.init();      
    }
  }

  AjaxCart.prototype = $.extend({}, AjaxCart.prototype, {

    /**
     * Theme Editor section events below
     */
    onSelect: function() {
      this.ajaxCart.open();
    },

    onDeselect: function() {
      this.ajaxCart.close();
    },

    onShow: function() {

    },

    onLoad: function() {

    },

    onUnload: function() {

    }
  });

  return AjaxCart;
})(jQuery);

/**
 * Mobile menu Section Script
 * ------------------------------------------------------------------------------
 * Exposes methods and events for the mobile menu
 *
 * @namespace - mobileMenu
 */

theme.MobileMenu = (function($) {

  var selectors = {
    toggle: '[data-mobile-menu-toggle]',
    menu: '[data-mobile-menu]'
  };

  function MobileMenu(container) {
    this.$container = $(container);

    this.name = 'mobileMenu';
    this.namespace = '.'+this.name;

    this.$el     = $(selectors.menu, this.$container);
    this.$toggle = $(selectors.toggle); // Don't scope to this.$container

    this.drawer  = new slate.models.Drawer(this.$el);

    this.$toggle.on('click', this.onToggleClick.bind(this));

  }

  MobileMenu.prototype = $.extend({}, MobileMenu.prototype, {

    onToggleClick: function(e) {
      e.preventDefault();
      this.drawer.toggle();
    },

    /**
     * Theme Editor section events below
     */
    onSelect: function() {
      this.drawer.show();
    },

    onDeselect: function() {
      this.drawer.hide();
    },

    onUnload: function() {
      this.drawer && $('.drawer-backdrop').remove();
    },
  });

  return MobileMenu;
})(jQuery);

/**
 * Blog Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - blog
 */

theme.Blog = (function($) {

  var selectors = {
    contentGrid: '.content-grid',
    contentGridItem: '.content-grid__item',
    pagination: '[data-pagination]',
    nextPageLink: '[data-next-page]',
  };

  function Blog(container) {

    this.$container = $(container);

    this.name = 'blog';
    this.namespace = '.'+this.name;

    this.$container.on('click', selectors.nextPageLink, this.onNextPageLinkClick.bind(this));
  }

  Blog.prototype = $.extend({}, Blog.prototype, {

    onNextPageLinkClick: function(e) {
      e.preventDefault();
      var self     = this;
      var $link    = $(e.currentTarget);
      var url      = $link.attr('href');

      $.ajax({
        url: url,
        beforeSend: function() {
          $link.html(theme.strings.loading || 'Loading');
        }
      })
      .done(function( data ) {
        var $dom = $(data);
        var $contentItems = $(selectors.contentGridItem, $dom);
        var $newNextPageLink = $(selectors.nextPageLink, $dom);

        $(selectors.contentGrid, self.$container).append($contentItems);

        if($newNextPageLink.length) {
          $link.replaceWith($newNextPageLink);
        }
        else {
          $(selectors.pagination, self.$container).remove();
        }
      });

    }
  });

  return Blog;
})(jQuery);

/**
 * Password Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - password
 */

theme.Password = (function($) {

  var selectors = {
    countdown: '[data-countdown]'
  };

  function Password(container) {

    this.$container = $(container);

    this.name = 'password';
    this.namespace = '.'+this.name;

    // this.$countdown = $(selectors.countdown, this.$container);

    // this.countDownInterval = null;
    // this.endTime = 'November 10 2018 06:00:00 GMT-0800'; // 6AM on Saturday

    // if(this.getRemainingTime(this.endTime).total <= 0) {
    //   return;
    // }

    // this.$countdown.css('opacity', 0);
    // this.startClock();
    // this.$countdown.animate({ opacity: 1 }, 3000);
  }

  Password.prototype = $.extend({}, Password.prototype, {
    tick: function() {
      var t = this.getRemainingTime(this.endTime);
      var time = [t.days, t.hours, t.minutes, t.seconds].map(function(n) { return slate.utils.pad(n, 2, 0)}).join(':');
      this.$countdown.text(time);

      if(t.total <= 0) {
        this.stopClock();
      }
    },
    startClock: function() {
      this.tick();
      this.countDownInterval = setInterval(this.tick.bind(this), 1000);
    },
    stopClock: function() {
      clearInterval(this.countDownInterval);
    },
    getRemainingTime: function(endTime) {
      var t = Date.parse(endTime) - Date.parse(new Date());
      var seconds = Math.floor( (t/1000) % 60 );
      var minutes = Math.floor( (t/1000/60) % 60 );
      var hours = Math.floor( (t/(1000*60*60)) % 24 );
      var days = Math.floor( t/(1000*60*60*24) );
      return {
        'total': t,
        'days': days,
        'hours': hours,
        'minutes': minutes,
        'seconds': seconds
      }; 
    }
  });

  return Password;
})(jQuery);

/**
 * Featured Product Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - featuredProduct
 */

theme.FeaturedProduct = (function($, scrollMonitor) {

  var selectors = {
    featuredProduct: '[data-featured-product]'
  };

  var classes = {
    hasBeenSeen: 'has-been-seen'
  };

  var $window = $(window);

  function FeaturedProduct(container) {
    this.name = 'featuredProduct';
    this.namespace = '.'+this.name;
    this.desktopBreakpoint = slate.breakpoints.getBreakpointMinWidth('md');
    this.easingFunction = slate.animations.easingFunctions.easeOutCubic;
    this.transformProperty = Modernizr.prefixedCSS('transform');
    this.scrollHandler = false;
    this.isInViewport = false;

    this.$container = $(container);

    // Cache these variables so we don't have to look them up everytime we scroll
    // These get updated on resize
    this.windowHeight    = $window.height();
    this.containerHeight = this.$container.outerHeight();

    this.events = {
      SCROLL: 'scroll' + this.namespace,
      RESIZE: 'resize' + this.namespace
    };

    this.callbacks = {
      onScroll: this.applyTransformations.bind(this),
      onResize: $.throttle(50, this.onResize.bind(this))
    }

    this.$featuredProduct = $(selectors.featuredProduct, this.$container);
    this.$featuredProductInfoWrap = $('.product-feature__info-wrap', this.$container);
    this.$featuredProductImage = this.$featuredProduct.find('img');

    this.scrollMonitorInstance = scrollMonitor.create(this.$featuredProduct.get(0), 0);
    this.scrollMonitorInstance.enterViewport(this.onEnterViewport.bind(this));
    this.scrollMonitorInstance.exitViewport(this.onExitViewport.bind(this));

    $window.on(this.events.RESIZE, this.callbacks.onResize);
  }

  FeaturedProduct.prototype = $.extend({}, FeaturedProduct.prototype, {

    attachScrollHandler: function() {
      if(this.scrollHandler || $window.width() < this.desktopBreakpoint) return;

      this.scrollHandler = true;
      $window.on(this.events.SCROLL, this.callbacks.onScroll);
    },

    onUnload() {
      this.scrollMonitorInstance && this.scrollMonitorInstance.destroy()
      $window.off(this.events.RESIZE, this.callbacks.onResize);
      $window.off(this.events.SCROLL, this.callbacks.onScroll);
    },

    removeScrollHandler: function() {
      if(this.scrollHandler == false || $window.width() >= this.desktopBreakpoint) return;

      this.scrollHandler = false;
      this.resetTransformations();
      $window.off(this.events.SCROLL, this.callbacks.onScroll);
    },

    onResize: function() {
      this.windowHeight = $window.height();
      this.containerHeight = this.$container.outerHeight();

      if($window.width() >= this.desktopBreakpoint) {
        this.applyTransformations();
      }
      else {
        this.removeScrollHandler();
      }
    },
    
    onEnterViewport: function() {
      this.$featuredProduct.addClass(classes.hasBeenSeen);
      this.isInViewport = true;
      this.attachScrollHandler();
    },

    onExitViewport: function() {
      this.isInViewport = false;
      this.removeScrollHandler();
    },

    applyTransformations: function() {
      // scrollProgress maps the amount we've scrolled between 0 and 1.  0 is when the section enters the viewport and 1 is when it leaves.
      // Lot of time spent figuring this part out, don't ask
      var numerator      = this.$container.offset()['top'] + this.containerHeight - $window.scrollTop();
      var denominator    = this.containerHeight + this.windowHeight;
      var scrollProgress = 1 - numerator/denominator;

      var scrollTranslatePxInfo = Math.round(((scrollProgress - 1/2) * 200) * 10) / 10; // this.easingFunction(scrollProgress) * (this.containerHeight * 0.08) * -1;
      var scrollTranslatePxImage = Math.round(((scrollProgress - 1/2) * 120) * 10) / 10;

      requestAnimationFrame(function() {
        this.$featuredProductInfoWrap.css(this.transformProperty, 'translateY(' + scrollTranslatePxInfo + 'px)');
        this.$featuredProductImage.css(this.transformProperty, 'translateY(-' + scrollTranslatePxImage + 'px)');
      }.bind(this));
    },

    resetTransformations: function() {
      requestAnimationFrame(function() {
        this.$featuredProductInfoWrap.css(this.transformProperty, '');
        this.$featuredProductImage.css(this.transformProperty, '');
      }.bind(this));
    }

  });

  return FeaturedProduct;
})(jQuery, scrollMonitor);

/**
 * HomeHero Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - homeHero
 */

theme.HomeHero = (function($) {

  var selectors = {
    configJson: '[data-config-json]',
    hero: '[data-hero]',
    videoCover: '[data-video-cover]'
  };

  var classes = {
    isReady: 'is-ready'
  };

  function HomeHero(container) {

    this.$container = $(container);

    this.name = 'homeHero';
    this.namespace = '.'+this.name;

    this.$hero = $(selectors.hero, this.$container);
    this.$videoCover = $(selectors.videoCover, this.$container);

    this.config = JSON.parse($(selectors.configJson, this.$container).html());
    this.blocks = this.config.blocks;

    var selectedBlock = this.blocks[Math.floor(Math.random() * this.blocks.length)];

    this.$hero.addClass('hero--' + selectedBlock.position);
    this.$videoCover.data('vimeo-id', selectedBlock.vimeo_id);

    this.scrollMonitorInstance = scrollMonitor.create(this.$hero.get(0), 0);
    this.scrollMonitorInstance.enterViewport(this.onEnterViewport.bind(this));
    this.scrollMonitorInstance.exitViewport(this.onExitViewport.bind(this));    

    if(/iPhone|iPod/.test(navigator.platform) || $(window).width() < slate.breakpoints.getBreakpointMinWidth('sm')) {
      this.$videoCover.remove();
      this.$hero.addClass(classes.isReady);
      return;
    }
    else {
      this.videoCover = new slate.models.VideoCover(this.$videoCover);
      this.$videoCover.on('ready.videoCover', function() {
        this.$hero.addClass(classes.isReady);
      }.bind(this));
    }

    // In case something goes wrong, add the ready class after a couple seconds
    setTimeout(function() {
      this.$hero.addClass(classes.isReady);
    }.bind(this), 5000); 
  }

  HomeHero.prototype = $.extend({}, HomeHero.prototype, {
    onEnterViewport: function() {
      this.videoCover && this.videoCover.play();
    },

    onExitViewport: function() {
      this.videoCover && this.videoCover.pause();
    }    
  });

  return HomeHero;
})(jQuery);

/**
 * LoginPrompt Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - loginPrompt
 */

 theme.LoginPrompt = (function($, slate) {

  var selectors = {
    modal: '[data-modal]',
    loginContent: '[data-login-content]',
    resetContent: '[data-reset-content]',
    registerContent: '[data-register-content]',
    showLogin: '[data-show-login]',
    showReset: '[data-show-reset]',
    showRegister: '[data-show-register]'
  };

  var classes = {

  };

  function LoginPrompt(container) {

    this.$container = $(container);

    this.name = 'loginPrompt';
    this.namespace = '.'+this.name;
    this.introTimeout = null;

    this.$modal = $(selectors.modal, this.$container);
    this.$loginContent = $(selectors.loginContent, this.$container);
    this.$resetContent = $(selectors.resetContent, this.$container);
    this.$registerContent = $(selectors.registerContent, this.$container);

    this.$modal.on('shown.bs.modal', this.onShown.bind(this));

    this.$container.on('click', selectors.showLogin, this.onShowLoginClick.bind(this));
    this.$container.on('click', selectors.showReset, this.onShowResetClick.bind(this));
    this.$container.on('click', selectors.showRegister, this.onShowRegisterClick.bind(this));

    if (slate.utils.isThemeEditor()) {
      return;
    }

    this.introTimeout = setTimeout(this.show.bind(this), 900);
  }

  LoginPrompt.prototype = $.extend({}, LoginPrompt.prototype, {
    show: function() {
      this.$modal.modal('show');
    },

    hide: function() {
      this.$modal.modal('hide');
    },

    onShowLoginClick: function(e) {
      e.preventDefault();

      this.$resetContent.hide();
      this.$loginContent.show();
      this.$registerContent.hide();  
    },

    onShowResetClick: function(e) {
      e.preventDefault();

      this.$resetContent.show();
      this.$loginContent.hide();
      this.$registerContent.hide();      
    },

    onShowRegisterClick: function(e) {
      e.preventDefault();

      this.$resetContent.hide();
      this.$loginContent.hide();
      this.$registerContent.show();  
    },

    onShown: function() {
      if (slate.utils.isThemeEditor()) {
        return;
      }

      this.$modal.find('input.form-control').filter(':visible').first().focus()
    },

    onSelect: function() {
      this.show();
    },
    
    onDeselect: function() {
      this.hide();
    },

    onUnload: function() {
      clearTimeout(this.introTimeout);
      this.hide();
      this.$modal.data('bs.modal', null);
    }
  });

  return LoginPrompt;
})(jQuery, slate);

/**
 * PageQrVansGoretex Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - mobileMenu
 */

 theme.PageQrVansGoretex = (function($) {

  var selectors = {
    mainVideoPlayer: '[data-qr-video-player-main]',
    easterEggVideoPlayer: '[data-qr-video-player-easter-egg]'
  };

  function VideoPlayer(el, options) {
    var defaults = {
      onEnded: $.noop,
      onCoverClick: $.noop
    };

    this.settings = $.extend({}, defaults, options);

    this.$el = $(el);
    this.$video = $('video', this.$el);
    this.$cover = $('[data-cover]', this.$el);

    this.video = this.$video.get(0)

    this.$video.on('play', this.onPlay.bind(this));
    this.$video.on('playing', this.onPlaying.bind(this));
    this.$video.on('ended', this.onEnded.bind(this));
    this.$cover.on('click', this.onCoverClick.bind(this));
  }

  VideoPlayer.prototype = $.extend({}, VideoPlayer.prototype, {
    play: function() {
      this.video.play();
    },

    unmute: function() {
      this.video.muted = false;
      this.video.volume = 1;
    },

    stop: function() {
      this.video.pause();
    },

    onPlay: function() {
      console.log('onplay')
    },

    onPlaying: function() {
      this.$el.addClass('is-playing');
      this.unmute();
    },

    onEnded: function() {
      this.settings.onEnded();
    },

    onCoverClick: function() {
      this.settings.onCoverClick();
    }
  });

  function PageQrVansGoretex(container) {
    this.$container = $(container);

    this.mainVideoEnded = false;

    this.mainVideoPlayer = new VideoPlayer($(selectors.mainVideoPlayer, this.$container), {
      onEnded: this.onMainVideoPlayerEnded.bind(this),
      onCoverClick: this.onMainVideoCoverClick.bind(this)
    });

    this.easterEggVideoPlayer = new VideoPlayer($(selectors.easterEggVideoPlayer, this.$container), {
      onEnded: this.onEasterEggVideoPlayerEnded.bind(this)
    })

  }

  PageQrVansGoretex.prototype = $.extend({}, PageQrVansGoretex.prototype, {
    onMainVideoPlayerEnded: function() {
      this.mainVideoEnded = true;
    },

    onMainVideoCoverClick: function() {
      if (this.mainVideoEnded) {
        this.easterEggVideoPlayer.$el.show();
        this.easterEggVideoPlayer.play();
      }
      else {
        this.mainVideoPlayer.play()
      }
    },

    onEasterEggVideoPlayerEnded: function() {
      this.easterEggVideoPlayer.$el.hide();
      this.mainVideoPlayer.$el.hide();
    },

    /**
     * Theme Editor section events below
     */
    onSelect: function() {
      this.mainVideoPlayer.pause();
      this.mainVideoPlayer.currentTime = 0;
    },

    onDeselect: function() {
      this.mainVideoPlayer.pause();
      this.mainVideoPlayer.currentTime = 0;
    },

    onUnload: function() {

    }
  });

  return PageQrVansGoretex;
})(jQuery);


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  var selectors = {
    addressNewToggle: '[data-address-new-toggle]',
    addressEditToggle: '[data-address-edit-toggle][data-form-id]',
    addressDelete: '[data-address-delete][data-form-id]'
  };

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $(selectors.addressNewToggle).on('click', function(e) {
    e.preventDefault();
    $newAddressForm.toggleClass('hide');
  });

  $(selectors.addressEditToggle).on('click', function(e) {
    e.preventDefault();
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $(selectors.addressDelete).on('click', function(e) {
    e.preventDefault();
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
    $('#RecoverPassword').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();

/**
 * Styleguide Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the styleguide page template.
 *
 * Use this to hook up any JS necessary to show element functionality.
 */

 theme.styleguide = (function() {
  
  var $body = $(document.body);
  
  var selectors = {
    dot: '.dot'
  };

  if( !$body.is('.template-page-styles') ){
    return;
  }

  $body.on('click', selectors.dot, function(){
    $(this).toggleClass('is-active');
  });

  $body.on('click', 'a[href="#"]', function(){
    return false;
  });

})();

/**
 * Styleguide Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the components page template.
 *
 * Use this to hook up any JS necessary to show element functionality.
 */

 theme.components = (function() {
  
  var $body = $(document.body);
  
  var selectors = {
    qaSetMax: '[data-qa-set-max]',
    qaToggleEnabled: '[data-qa-toggle-enabled]',
    qa: '[data-quantity-adjuster]'
  };

  if( !$body.is('.template-page-components') ){
    return;
  }

  // Quantity Adjuster
  $(selectors.qaSetMax).on('click', function(e) {
    $(selectors.qa).find('input[type="number"]').attr('max', $(e.currentTarget).data('qa-set-max'));
  });

  $(selectors.qaToggleEnabled).on('click', function(e) {
    var $qaInput = $(selectors.qa).find('input[type="number"]');
    $qaInput.attr('disabled', !$qaInput.is(':disabled'));
  });

  $body.on('click', 'a[href="#"]', function(){
    return false;
  });

})();


(function($) {

  var $window       = $(window);
  var $document     = $(document);
  var $body         = $(document.body);

  $(document).ready(function() {
    var sections = new slate.Sections();
    sections.register('product', theme.Product);
    sections.register('collection', theme.Collection);
    sections.register('subscription-modal', theme.SubscriptionModal);
    sections.register('slideshow', theme.Slideshow);
    sections.register('header', theme.Header);
    sections.register('footer', theme.Footer);
    sections.register('ajax-cart', theme.AjaxCart);
    sections.register('mobile-menu', theme.MobileMenu);
    sections.register('blog', theme.Blog);
    sections.register('password', theme.Password);
    sections.register('featured-product', theme.FeaturedProduct);
    sections.register('home-hero', theme.HomeHero);
    sections.register('login-prompt', theme.LoginPrompt);
    sections.register('page-qr-vans-goretex', theme.PageQrVansGoretex);

    $('.in-page-link').on('click', function(evt) {
      slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
    });

    // Common a11y fixes
    slate.a11y.pageLinkFocus($(window.location.hash));    

    // Target tables to make them scrollable
    slate.rte.wrapTables({
      $tables: $('.rte table'),
      tableWrapperClass: 'table-responsive'
    });

    // Target iframes to make them responsive
    var iframeSelectors =
      '.rte iframe[src*="youtube.com/embed"],' +
      '.rte iframe[src*="player.vimeo"]';

    slate.rte.wrapIframe({
      $iframes: $(iframeSelectors),
      iframeWrapperClass: 'rte__video-wrapper'
    });

    // Apply UA classes to the document
    slate.utils.userAgentBodyClass();    

    // Apply a specific class to the html element for browser support of cookies.
    if (slate.utils.cookiesEnabled()) {
      document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
    }

    // Chosen JS plugin for select boxes
    slate.utils.chosenSelects();

    // Form event handling / validation
    slate.forms.initialize();

    // START - Global handler for collapse plugin to add state class for open panels
    var panelIsOpenClass = 'is-open';

    $document.on('show.bs.collapse', '.collapse', function(e) {
      $(e.currentTarget).parents('.panel').addClass(panelIsOpenClass);
    });

    $document.on('hide.bs.collapse', '.collapse', function(e) {
      $(e.currentTarget).parents('.panel').removeClass(panelIsOpenClass);
    });    

    $('.collapse.in').each(function() {
      $(this).parents('.panel').addClass(panelIsOpenClass);
    });
    // END - Global handler for collapse plugin to add state class for open panels

    if (window && window.location && window.location.hostname !== 'localhost') {
      // eslint-disable-next-line no-console, max-len
      console.log('%c ⚡️ DEFCON GROUP ⚡️', 'font-family: OCR-B, Courier; font-size: 15px; color: white; background-color: black; font-weight: bold;');
      console.log('%c design + development → Stefan Bowerman - https://stefanbowerman.com', 'font-family: OCR-B, Courier; font-size: 11px; color: white; background-color: black;;');
    }    
  });

}(jQuery));
